/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RecoverPasswordRouteImport } from './routes/recover-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutUserSettingsRouteImport } from './routes/_layout/user-settings'
import { Route as LayoutSettingsRouteImport } from './routes/_layout/settings'
import { Route as LayoutDeveloperProfileRouteImport } from './routes/_layout/developer-profile'
import { Route as LayoutCompanySettingsRouteImport } from './routes/_layout/company-settings'
import { Route as LayoutCompanySettingsIndexRouteImport } from './routes/_layout/company-settings/index'
import { Route as LayoutAdminIndexRouteImport } from './routes/_layout/admin/index'
import { Route as LayoutAdminRolesRouteImport } from './routes/_layout/admin/roles'
import { Route as LayoutAdminLicenseStatusRouteImport } from './routes/_layout/admin/license-status'
import { Route as LayoutWMSDashboardRouteImport } from './routes/_layout/WMS/dashboard'
import { Route as LayoutWMSTechnologiesIndexRouteImport } from './routes/_layout/WMS/technologies/index'
import { Route as LayoutWMSProductionOrdersIndexRouteImport } from './routes/_layout/WMS/production-orders/index'
import { Route as LayoutWMSKsefIndexRouteImport } from './routes/_layout/WMS/ksef/index'
import { Route as LayoutWMSAutoReplenishmentIndexRouteImport } from './routes/_layout/WMS/auto-replenishment/index'
import { Route as LayoutCompanySettingsRevisionsRevisionIdRouteImport } from './routes/_layout/company-settings/revisions/$revisionId'
import { Route as LayoutAdminUsersUserIdRouteImport } from './routes/_layout/admin/users.$userId'
import { Route as LayoutWMSWarehousesWarehousesListRouteImport } from './routes/_layout/WMS/warehouses/warehouses-list'
import { Route as LayoutWMSWarehousesLocationTemplatesRouteImport } from './routes/_layout/WMS/warehouses/location-templates'
import { Route as LayoutWMSWarehousesExpirationDateReportsRouteImport } from './routes/_layout/WMS/warehouses/expiration-date-reports'
import { Route as LayoutWMSWarehousesCriticalStockReportsRouteImport } from './routes/_layout/WMS/warehouses/critical-stock-reports'
import { Route as LayoutWMSWarehousesWarehouseRouteImport } from './routes/_layout/WMS/warehouses/$warehouse'
import { Route as LayoutWMSTechnologiesTreeRouteImport } from './routes/_layout/WMS/technologies/tree'
import { Route as LayoutWMSTechnologiesTechnologiesListRouteImport } from './routes/_layout/WMS/technologies/technologies-list'
import { Route as LayoutWMSTechnologiesCreateRouteImport } from './routes/_layout/WMS/technologies/create'
import { Route as LayoutWMSTechnologiesTechnologyRouteImport } from './routes/_layout/WMS/technologies/$technology'
import { Route as LayoutWMSSearchGlobalSearchRouteImport } from './routes/_layout/WMS/search/global-search'
import { Route as LayoutWMSReportsMmpDiscrepanciesRouteImport } from './routes/_layout/WMS/reports/mmp-discrepancies'
import { Route as LayoutWMSReportsInventoryCountAlertsRouteImport } from './routes/_layout/WMS/reports/inventory-count-alerts'
import { Route as LayoutWMSProductsProductsListRouteImport } from './routes/_layout/WMS/products/products-list'
import { Route as LayoutWMSProductsPrintAgentRouteImport } from './routes/_layout/WMS/products/print-agent'
import { Route as LayoutWMSProductsLabelTemplatesRouteImport } from './routes/_layout/WMS/products/label-templates'
import { Route as LayoutWMSProductsLabelAssetsRouteImport } from './routes/_layout/WMS/products/label-assets'
import { Route as LayoutWMSProductsCreateRouteImport } from './routes/_layout/WMS/products/create'
import { Route as LayoutWMSProductsCourierLabelsRouteImport } from './routes/_layout/WMS/products/courier-labels'
import { Route as LayoutWMSProductsProductRouteImport } from './routes/_layout/WMS/products/$product'
import { Route as LayoutWMSProductionOrdersProductionOrdersListRouteImport } from './routes/_layout/WMS/production-orders/production-orders-list'
import { Route as LayoutWMSProductionOrdersCreateRouteImport } from './routes/_layout/WMS/production-orders/create'
import { Route as LayoutWMSProductionOrdersChainRouteImport } from './routes/_layout/WMS/production-orders/chain'
import { Route as LayoutWMSProductionOrdersOrderRouteImport } from './routes/_layout/WMS/production-orders/$order'
import { Route as LayoutWMSKsefSettingsRouteImport } from './routes/_layout/WMS/ksef/settings'
import { Route as LayoutWMSKsefFzRouteImport } from './routes/_layout/WMS/ksef/fz'
import { Route as LayoutWMSKsefInvoiceIdRouteImport } from './routes/_layout/WMS/ksef/$invoiceId'
import { Route as LayoutWMSInventoryCountTasksRouteImport } from './routes/_layout/WMS/inventory-count/tasks'
import { Route as LayoutWMSInventoryCountReviewRouteImport } from './routes/_layout/WMS/inventory-count/review'
import { Route as LayoutWMSInventoryCountPlansRouteImport } from './routes/_layout/WMS/inventory-count/plans'
import { Route as LayoutWMSInventoryCountInstructionsWorkerRouteImport } from './routes/_layout/WMS/inventory-count/instructions-worker'
import { Route as LayoutWMSInventoryCountInstructionsOperatorRouteImport } from './routes/_layout/WMS/inventory-count/instructions-operator'
import { Route as LayoutWMSInventoryCountDashboardRouteImport } from './routes/_layout/WMS/inventory-count/dashboard'
import { Route as LayoutWMSDocumentsDocumentListRouteImport } from './routes/_layout/WMS/documents/document-list'
import { Route as LayoutWMSContragentsCreateRouteImport } from './routes/_layout/WMS/contragents/create'
import { Route as LayoutWMSContragentsContragentsListRouteImport } from './routes/_layout/WMS/contragents/contragents-list'
import { Route as LayoutWMSContragentsContragentIdRouteImport } from './routes/_layout/WMS/contragents/$contragentId'
import { Route as LayoutWMSAutoReplenishmentRequestsRouteImport } from './routes/_layout/WMS/auto-replenishment/requests'
import { Route as LayoutWMSAutoReplenishmentPoliciesRouteImport } from './routes/_layout/WMS/auto-replenishment/policies'
import { Route as LayoutWMSAutoReplenishmentOverviewRouteImport } from './routes/_layout/WMS/auto-replenishment/overview'
import { Route as LayoutWMSTechnologiesFlowsIndexRouteImport } from './routes/_layout/WMS/technologies/flows/index'
import { Route as LayoutWMSAutoReplenishmentRequestsIndexRouteImport } from './routes/_layout/WMS/auto-replenishment/requests.index'
import { Route as LayoutWMSWarehousesExpirationDateReportIdRouteImport } from './routes/_layout/WMS/warehouses/expiration-date-report.$id'
import { Route as LayoutWMSWarehousesCriticalStockReportIdRouteImport } from './routes/_layout/WMS/warehouses/critical-stock-report.$id'
import { Route as LayoutWMSTechnologiesFlowsFlowIdRouteImport } from './routes/_layout/WMS/technologies/flows/$flowId'
import { Route as LayoutWMSInventoryCountTasksTaskIdRouteImport } from './routes/_layout/WMS/inventory-count/tasks/$taskId'
import { Route as LayoutWMSDocumentsZapNewRouteImport } from './routes/_layout/WMS/documents/zap/new'
import { Route as LayoutWMSDocumentsZapZapRouteImport } from './routes/_layout/WMS/documents/zap/$zap'
import { Route as LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRouteImport } from './routes/_layout/WMS/documents/warehouse-orders/$warehouseOrder'
import { Route as LayoutWMSDocumentsSalesOrdersNewRouteImport } from './routes/_layout/WMS/documents/sales-orders/new'
import { Route as LayoutWMSDocumentsSalesOrdersSalesOrderRouteImport } from './routes/_layout/WMS/documents/sales-orders/$salesOrder'
import { Route as LayoutWMSDocumentsSalesOffersNewRouteImport } from './routes/_layout/WMS/documents/sales-offers/new'
import { Route as LayoutWMSDocumentsSalesOffersSalesOfferRouteImport } from './routes/_layout/WMS/documents/sales-offers/$salesOffer'
import { Route as LayoutWMSDocumentsPurchaseOrdersNewRouteImport } from './routes/_layout/WMS/documents/purchase-orders/new'
import { Route as LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRouteImport } from './routes/_layout/WMS/documents/purchase-orders/$purchaseOrder'
import { Route as LayoutWMSDocumentsExReleasesNewRouteImport } from './routes/_layout/WMS/documents/ex-releases/new'
import { Route as LayoutWMSDocumentsExReleasesExReleaseRouteImport } from './routes/_layout/WMS/documents/ex-releases/$exRelease'
import { Route as LayoutWMSDocumentsExReceptionsNewRouteImport } from './routes/_layout/WMS/documents/ex-receptions/new'
import { Route as LayoutWMSDocumentsExReceptionsExReceptionRouteImport } from './routes/_layout/WMS/documents/ex-receptions/$exReception'
import { Route as LayoutWMSDocumentsDocRwNewRouteImport } from './routes/_layout/WMS/documents/doc-rw/new'
import { Route as LayoutWMSDocumentsDocRwDocRwRouteImport } from './routes/_layout/WMS/documents/doc-rw/$docRw'
import { Route as LayoutWMSDocumentsDocPwNewRouteImport } from './routes/_layout/WMS/documents/doc-pw/new'
import { Route as LayoutWMSDocumentsDocPwDocPwRouteImport } from './routes/_layout/WMS/documents/doc-pw/$docPw'
import { Route as LayoutWMSDocumentsDocMmwNewRouteImport } from './routes/_layout/WMS/documents/doc-mmw/new'
import { Route as LayoutWMSDocumentsDocMmwDocMmwRouteImport } from './routes/_layout/WMS/documents/doc-mmw/$docMmw'
import { Route as LayoutWMSDocumentsDocMmrDocMmrRouteImport } from './routes/_layout/WMS/documents/doc-mmr/$docMmr'
import { Route as LayoutWMSDocumentsDocMmpDocMmpRouteImport } from './routes/_layout/WMS/documents/doc-mmp/$docMmp'
import { Route as LayoutWMSDocumentsDocKiDocKiRouteImport } from './routes/_layout/WMS/documents/doc-ki/$docKi'
import { Route as LayoutWMSAutoReplenishmentRequestsRequestIdRouteImport } from './routes/_layout/WMS/auto-replenishment/requests/$requestId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverPasswordRoute = RecoverPasswordRouteImport.update({
  id: '/recover-password',
  path: '/recover-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutUserSettingsRoute = LayoutUserSettingsRouteImport.update({
  id: '/user-settings',
  path: '/user-settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsRoute = LayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDeveloperProfileRoute = LayoutDeveloperProfileRouteImport.update({
  id: '/developer-profile',
  path: '/developer-profile',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCompanySettingsRoute = LayoutCompanySettingsRouteImport.update({
  id: '/company-settings',
  path: '/company-settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutCompanySettingsIndexRoute =
  LayoutCompanySettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutCompanySettingsRoute,
  } as any)
const LayoutAdminIndexRoute = LayoutAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAdminRolesRoute = LayoutAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAdminLicenseStatusRoute =
  LayoutAdminLicenseStatusRouteImport.update({
    id: '/admin/license-status',
    path: '/admin/license-status',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDashboardRoute = LayoutWMSDashboardRouteImport.update({
  id: '/WMS/dashboard',
  path: '/WMS/dashboard',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutWMSTechnologiesIndexRoute =
  LayoutWMSTechnologiesIndexRouteImport.update({
    id: '/WMS/technologies/',
    path: '/WMS/technologies/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductionOrdersIndexRoute =
  LayoutWMSProductionOrdersIndexRouteImport.update({
    id: '/WMS/production-orders/',
    path: '/WMS/production-orders/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSKsefIndexRoute = LayoutWMSKsefIndexRouteImport.update({
  id: '/WMS/ksef/',
  path: '/WMS/ksef/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutWMSAutoReplenishmentIndexRoute =
  LayoutWMSAutoReplenishmentIndexRouteImport.update({
    id: '/WMS/auto-replenishment/',
    path: '/WMS/auto-replenishment/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutCompanySettingsRevisionsRevisionIdRoute =
  LayoutCompanySettingsRevisionsRevisionIdRouteImport.update({
    id: '/revisions/$revisionId',
    path: '/revisions/$revisionId',
    getParentRoute: () => LayoutCompanySettingsRoute,
  } as any)
const LayoutAdminUsersUserIdRoute = LayoutAdminUsersUserIdRouteImport.update({
  id: '/admin/users/$userId',
  path: '/admin/users/$userId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutWMSWarehousesWarehousesListRoute =
  LayoutWMSWarehousesWarehousesListRouteImport.update({
    id: '/WMS/warehouses/warehouses-list',
    path: '/WMS/warehouses/warehouses-list',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSWarehousesLocationTemplatesRoute =
  LayoutWMSWarehousesLocationTemplatesRouteImport.update({
    id: '/WMS/warehouses/location-templates',
    path: '/WMS/warehouses/location-templates',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSWarehousesExpirationDateReportsRoute =
  LayoutWMSWarehousesExpirationDateReportsRouteImport.update({
    id: '/WMS/warehouses/expiration-date-reports',
    path: '/WMS/warehouses/expiration-date-reports',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSWarehousesCriticalStockReportsRoute =
  LayoutWMSWarehousesCriticalStockReportsRouteImport.update({
    id: '/WMS/warehouses/critical-stock-reports',
    path: '/WMS/warehouses/critical-stock-reports',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSWarehousesWarehouseRoute =
  LayoutWMSWarehousesWarehouseRouteImport.update({
    id: '/WMS/warehouses/$warehouse',
    path: '/WMS/warehouses/$warehouse',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSTechnologiesTreeRoute =
  LayoutWMSTechnologiesTreeRouteImport.update({
    id: '/WMS/technologies/tree',
    path: '/WMS/technologies/tree',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSTechnologiesTechnologiesListRoute =
  LayoutWMSTechnologiesTechnologiesListRouteImport.update({
    id: '/WMS/technologies/technologies-list',
    path: '/WMS/technologies/technologies-list',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSTechnologiesCreateRoute =
  LayoutWMSTechnologiesCreateRouteImport.update({
    id: '/WMS/technologies/create',
    path: '/WMS/technologies/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSTechnologiesTechnologyRoute =
  LayoutWMSTechnologiesTechnologyRouteImport.update({
    id: '/WMS/technologies/$technology',
    path: '/WMS/technologies/$technology',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSSearchGlobalSearchRoute =
  LayoutWMSSearchGlobalSearchRouteImport.update({
    id: '/WMS/search/global-search',
    path: '/WMS/search/global-search',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSReportsMmpDiscrepanciesRoute =
  LayoutWMSReportsMmpDiscrepanciesRouteImport.update({
    id: '/WMS/reports/mmp-discrepancies',
    path: '/WMS/reports/mmp-discrepancies',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSReportsInventoryCountAlertsRoute =
  LayoutWMSReportsInventoryCountAlertsRouteImport.update({
    id: '/WMS/reports/inventory-count-alerts',
    path: '/WMS/reports/inventory-count-alerts',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductsProductsListRoute =
  LayoutWMSProductsProductsListRouteImport.update({
    id: '/WMS/products/products-list',
    path: '/WMS/products/products-list',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductsPrintAgentRoute =
  LayoutWMSProductsPrintAgentRouteImport.update({
    id: '/WMS/products/print-agent',
    path: '/WMS/products/print-agent',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductsLabelTemplatesRoute =
  LayoutWMSProductsLabelTemplatesRouteImport.update({
    id: '/WMS/products/label-templates',
    path: '/WMS/products/label-templates',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductsLabelAssetsRoute =
  LayoutWMSProductsLabelAssetsRouteImport.update({
    id: '/WMS/products/label-assets',
    path: '/WMS/products/label-assets',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductsCreateRoute = LayoutWMSProductsCreateRouteImport.update({
  id: '/WMS/products/create',
  path: '/WMS/products/create',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutWMSProductsCourierLabelsRoute =
  LayoutWMSProductsCourierLabelsRouteImport.update({
    id: '/WMS/products/courier-labels',
    path: '/WMS/products/courier-labels',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductsProductRoute =
  LayoutWMSProductsProductRouteImport.update({
    id: '/WMS/products/$product',
    path: '/WMS/products/$product',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductionOrdersProductionOrdersListRoute =
  LayoutWMSProductionOrdersProductionOrdersListRouteImport.update({
    id: '/WMS/production-orders/production-orders-list',
    path: '/WMS/production-orders/production-orders-list',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductionOrdersCreateRoute =
  LayoutWMSProductionOrdersCreateRouteImport.update({
    id: '/WMS/production-orders/create',
    path: '/WMS/production-orders/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductionOrdersChainRoute =
  LayoutWMSProductionOrdersChainRouteImport.update({
    id: '/WMS/production-orders/chain',
    path: '/WMS/production-orders/chain',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSProductionOrdersOrderRoute =
  LayoutWMSProductionOrdersOrderRouteImport.update({
    id: '/WMS/production-orders/$order',
    path: '/WMS/production-orders/$order',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSKsefSettingsRoute = LayoutWMSKsefSettingsRouteImport.update({
  id: '/WMS/ksef/settings',
  path: '/WMS/ksef/settings',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutWMSKsefFzRoute = LayoutWMSKsefFzRouteImport.update({
  id: '/WMS/ksef/fz',
  path: '/WMS/ksef/fz',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutWMSKsefInvoiceIdRoute = LayoutWMSKsefInvoiceIdRouteImport.update({
  id: '/WMS/ksef/$invoiceId',
  path: '/WMS/ksef/$invoiceId',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutWMSInventoryCountTasksRoute =
  LayoutWMSInventoryCountTasksRouteImport.update({
    id: '/WMS/inventory-count/tasks',
    path: '/WMS/inventory-count/tasks',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSInventoryCountReviewRoute =
  LayoutWMSInventoryCountReviewRouteImport.update({
    id: '/WMS/inventory-count/review',
    path: '/WMS/inventory-count/review',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSInventoryCountPlansRoute =
  LayoutWMSInventoryCountPlansRouteImport.update({
    id: '/WMS/inventory-count/plans',
    path: '/WMS/inventory-count/plans',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSInventoryCountInstructionsWorkerRoute =
  LayoutWMSInventoryCountInstructionsWorkerRouteImport.update({
    id: '/WMS/inventory-count/instructions-worker',
    path: '/WMS/inventory-count/instructions-worker',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSInventoryCountInstructionsOperatorRoute =
  LayoutWMSInventoryCountInstructionsOperatorRouteImport.update({
    id: '/WMS/inventory-count/instructions-operator',
    path: '/WMS/inventory-count/instructions-operator',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSInventoryCountDashboardRoute =
  LayoutWMSInventoryCountDashboardRouteImport.update({
    id: '/WMS/inventory-count/dashboard',
    path: '/WMS/inventory-count/dashboard',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsDocumentListRoute =
  LayoutWMSDocumentsDocumentListRouteImport.update({
    id: '/WMS/documents/document-list',
    path: '/WMS/documents/document-list',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSContragentsCreateRoute =
  LayoutWMSContragentsCreateRouteImport.update({
    id: '/WMS/contragents/create',
    path: '/WMS/contragents/create',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSContragentsContragentsListRoute =
  LayoutWMSContragentsContragentsListRouteImport.update({
    id: '/WMS/contragents/contragents-list',
    path: '/WMS/contragents/contragents-list',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSContragentsContragentIdRoute =
  LayoutWMSContragentsContragentIdRouteImport.update({
    id: '/WMS/contragents/$contragentId',
    path: '/WMS/contragents/$contragentId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSAutoReplenishmentRequestsRoute =
  LayoutWMSAutoReplenishmentRequestsRouteImport.update({
    id: '/WMS/auto-replenishment/requests',
    path: '/WMS/auto-replenishment/requests',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSAutoReplenishmentPoliciesRoute =
  LayoutWMSAutoReplenishmentPoliciesRouteImport.update({
    id: '/WMS/auto-replenishment/policies',
    path: '/WMS/auto-replenishment/policies',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSAutoReplenishmentOverviewRoute =
  LayoutWMSAutoReplenishmentOverviewRouteImport.update({
    id: '/WMS/auto-replenishment/overview',
    path: '/WMS/auto-replenishment/overview',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSTechnologiesFlowsIndexRoute =
  LayoutWMSTechnologiesFlowsIndexRouteImport.update({
    id: '/WMS/technologies/flows/',
    path: '/WMS/technologies/flows/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSAutoReplenishmentRequestsIndexRoute =
  LayoutWMSAutoReplenishmentRequestsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutWMSAutoReplenishmentRequestsRoute,
  } as any)
const LayoutWMSWarehousesExpirationDateReportIdRoute =
  LayoutWMSWarehousesExpirationDateReportIdRouteImport.update({
    id: '/WMS/warehouses/expiration-date-report/$id',
    path: '/WMS/warehouses/expiration-date-report/$id',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSWarehousesCriticalStockReportIdRoute =
  LayoutWMSWarehousesCriticalStockReportIdRouteImport.update({
    id: '/WMS/warehouses/critical-stock-report/$id',
    path: '/WMS/warehouses/critical-stock-report/$id',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSTechnologiesFlowsFlowIdRoute =
  LayoutWMSTechnologiesFlowsFlowIdRouteImport.update({
    id: '/WMS/technologies/flows/$flowId',
    path: '/WMS/technologies/flows/$flowId',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSInventoryCountTasksTaskIdRoute =
  LayoutWMSInventoryCountTasksTaskIdRouteImport.update({
    id: '/$taskId',
    path: '/$taskId',
    getParentRoute: () => LayoutWMSInventoryCountTasksRoute,
  } as any)
const LayoutWMSDocumentsZapNewRoute =
  LayoutWMSDocumentsZapNewRouteImport.update({
    id: '/WMS/documents/zap/new',
    path: '/WMS/documents/zap/new',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsZapZapRoute =
  LayoutWMSDocumentsZapZapRouteImport.update({
    id: '/WMS/documents/zap/$zap',
    path: '/WMS/documents/zap/$zap',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRoute =
  LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRouteImport.update({
    id: '/WMS/documents/warehouse-orders/$warehouseOrder',
    path: '/WMS/documents/warehouse-orders/$warehouseOrder',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsSalesOrdersNewRoute =
  LayoutWMSDocumentsSalesOrdersNewRouteImport.update({
    id: '/WMS/documents/sales-orders/new',
    path: '/WMS/documents/sales-orders/new',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsSalesOrdersSalesOrderRoute =
  LayoutWMSDocumentsSalesOrdersSalesOrderRouteImport.update({
    id: '/WMS/documents/sales-orders/$salesOrder',
    path: '/WMS/documents/sales-orders/$salesOrder',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsSalesOffersNewRoute =
  LayoutWMSDocumentsSalesOffersNewRouteImport.update({
    id: '/WMS/documents/sales-offers/new',
    path: '/WMS/documents/sales-offers/new',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsSalesOffersSalesOfferRoute =
  LayoutWMSDocumentsSalesOffersSalesOfferRouteImport.update({
    id: '/WMS/documents/sales-offers/$salesOffer',
    path: '/WMS/documents/sales-offers/$salesOffer',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsPurchaseOrdersNewRoute =
  LayoutWMSDocumentsPurchaseOrdersNewRouteImport.update({
    id: '/WMS/documents/purchase-orders/new',
    path: '/WMS/documents/purchase-orders/new',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRoute =
  LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRouteImport.update({
    id: '/WMS/documents/purchase-orders/$purchaseOrder',
    path: '/WMS/documents/purchase-orders/$purchaseOrder',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsExReleasesNewRoute =
  LayoutWMSDocumentsExReleasesNewRouteImport.update({
    id: '/WMS/documents/ex-releases/new',
    path: '/WMS/documents/ex-releases/new',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsExReleasesExReleaseRoute =
  LayoutWMSDocumentsExReleasesExReleaseRouteImport.update({
    id: '/WMS/documents/ex-releases/$exRelease',
    path: '/WMS/documents/ex-releases/$exRelease',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsExReceptionsNewRoute =
  LayoutWMSDocumentsExReceptionsNewRouteImport.update({
    id: '/WMS/documents/ex-receptions/new',
    path: '/WMS/documents/ex-receptions/new',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsExReceptionsExReceptionRoute =
  LayoutWMSDocumentsExReceptionsExReceptionRouteImport.update({
    id: '/WMS/documents/ex-receptions/$exReception',
    path: '/WMS/documents/ex-receptions/$exReception',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsDocRwNewRoute =
  LayoutWMSDocumentsDocRwNewRouteImport.update({
    id: '/WMS/documents/doc-rw/new',
    path: '/WMS/documents/doc-rw/new',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsDocRwDocRwRoute =
  LayoutWMSDocumentsDocRwDocRwRouteImport.update({
    id: '/WMS/documents/doc-rw/$docRw',
    path: '/WMS/documents/doc-rw/$docRw',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsDocPwNewRoute =
  LayoutWMSDocumentsDocPwNewRouteImport.update({
    id: '/WMS/documents/doc-pw/new',
    path: '/WMS/documents/doc-pw/new',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsDocPwDocPwRoute =
  LayoutWMSDocumentsDocPwDocPwRouteImport.update({
    id: '/WMS/documents/doc-pw/$docPw',
    path: '/WMS/documents/doc-pw/$docPw',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsDocMmwNewRoute =
  LayoutWMSDocumentsDocMmwNewRouteImport.update({
    id: '/WMS/documents/doc-mmw/new',
    path: '/WMS/documents/doc-mmw/new',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsDocMmwDocMmwRoute =
  LayoutWMSDocumentsDocMmwDocMmwRouteImport.update({
    id: '/WMS/documents/doc-mmw/$docMmw',
    path: '/WMS/documents/doc-mmw/$docMmw',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsDocMmrDocMmrRoute =
  LayoutWMSDocumentsDocMmrDocMmrRouteImport.update({
    id: '/WMS/documents/doc-mmr/$docMmr',
    path: '/WMS/documents/doc-mmr/$docMmr',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsDocMmpDocMmpRoute =
  LayoutWMSDocumentsDocMmpDocMmpRouteImport.update({
    id: '/WMS/documents/doc-mmp/$docMmp',
    path: '/WMS/documents/doc-mmp/$docMmp',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSDocumentsDocKiDocKiRoute =
  LayoutWMSDocumentsDocKiDocKiRouteImport.update({
    id: '/WMS/documents/doc-ki/$docKi',
    path: '/WMS/documents/doc-ki/$docKi',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWMSAutoReplenishmentRequestsRequestIdRoute =
  LayoutWMSAutoReplenishmentRequestsRequestIdRouteImport.update({
    id: '/$requestId',
    path: '/$requestId',
    getParentRoute: () => LayoutWMSAutoReplenishmentRequestsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/company-settings': typeof LayoutCompanySettingsRouteWithChildren
  '/developer-profile': typeof LayoutDeveloperProfileRoute
  '/settings': typeof LayoutSettingsRoute
  '/user-settings': typeof LayoutUserSettingsRoute
  '/WMS/dashboard': typeof LayoutWMSDashboardRoute
  '/admin/license-status': typeof LayoutAdminLicenseStatusRoute
  '/admin/roles': typeof LayoutAdminRolesRoute
  '/admin/': typeof LayoutAdminIndexRoute
  '/company-settings/': typeof LayoutCompanySettingsIndexRoute
  '/WMS/auto-replenishment/overview': typeof LayoutWMSAutoReplenishmentOverviewRoute
  '/WMS/auto-replenishment/policies': typeof LayoutWMSAutoReplenishmentPoliciesRoute
  '/WMS/auto-replenishment/requests': typeof LayoutWMSAutoReplenishmentRequestsRouteWithChildren
  '/WMS/contragents/$contragentId': typeof LayoutWMSContragentsContragentIdRoute
  '/WMS/contragents/contragents-list': typeof LayoutWMSContragentsContragentsListRoute
  '/WMS/contragents/create': typeof LayoutWMSContragentsCreateRoute
  '/WMS/documents/document-list': typeof LayoutWMSDocumentsDocumentListRoute
  '/WMS/inventory-count/dashboard': typeof LayoutWMSInventoryCountDashboardRoute
  '/WMS/inventory-count/instructions-operator': typeof LayoutWMSInventoryCountInstructionsOperatorRoute
  '/WMS/inventory-count/instructions-worker': typeof LayoutWMSInventoryCountInstructionsWorkerRoute
  '/WMS/inventory-count/plans': typeof LayoutWMSInventoryCountPlansRoute
  '/WMS/inventory-count/review': typeof LayoutWMSInventoryCountReviewRoute
  '/WMS/inventory-count/tasks': typeof LayoutWMSInventoryCountTasksRouteWithChildren
  '/WMS/ksef/$invoiceId': typeof LayoutWMSKsefInvoiceIdRoute
  '/WMS/ksef/fz': typeof LayoutWMSKsefFzRoute
  '/WMS/ksef/settings': typeof LayoutWMSKsefSettingsRoute
  '/WMS/production-orders/$order': typeof LayoutWMSProductionOrdersOrderRoute
  '/WMS/production-orders/chain': typeof LayoutWMSProductionOrdersChainRoute
  '/WMS/production-orders/create': typeof LayoutWMSProductionOrdersCreateRoute
  '/WMS/production-orders/production-orders-list': typeof LayoutWMSProductionOrdersProductionOrdersListRoute
  '/WMS/products/$product': typeof LayoutWMSProductsProductRoute
  '/WMS/products/courier-labels': typeof LayoutWMSProductsCourierLabelsRoute
  '/WMS/products/create': typeof LayoutWMSProductsCreateRoute
  '/WMS/products/label-assets': typeof LayoutWMSProductsLabelAssetsRoute
  '/WMS/products/label-templates': typeof LayoutWMSProductsLabelTemplatesRoute
  '/WMS/products/print-agent': typeof LayoutWMSProductsPrintAgentRoute
  '/WMS/products/products-list': typeof LayoutWMSProductsProductsListRoute
  '/WMS/reports/inventory-count-alerts': typeof LayoutWMSReportsInventoryCountAlertsRoute
  '/WMS/reports/mmp-discrepancies': typeof LayoutWMSReportsMmpDiscrepanciesRoute
  '/WMS/search/global-search': typeof LayoutWMSSearchGlobalSearchRoute
  '/WMS/technologies/$technology': typeof LayoutWMSTechnologiesTechnologyRoute
  '/WMS/technologies/create': typeof LayoutWMSTechnologiesCreateRoute
  '/WMS/technologies/technologies-list': typeof LayoutWMSTechnologiesTechnologiesListRoute
  '/WMS/technologies/tree': typeof LayoutWMSTechnologiesTreeRoute
  '/WMS/warehouses/$warehouse': typeof LayoutWMSWarehousesWarehouseRoute
  '/WMS/warehouses/critical-stock-reports': typeof LayoutWMSWarehousesCriticalStockReportsRoute
  '/WMS/warehouses/expiration-date-reports': typeof LayoutWMSWarehousesExpirationDateReportsRoute
  '/WMS/warehouses/location-templates': typeof LayoutWMSWarehousesLocationTemplatesRoute
  '/WMS/warehouses/warehouses-list': typeof LayoutWMSWarehousesWarehousesListRoute
  '/admin/users/$userId': typeof LayoutAdminUsersUserIdRoute
  '/company-settings/revisions/$revisionId': typeof LayoutCompanySettingsRevisionsRevisionIdRoute
  '/WMS/auto-replenishment/': typeof LayoutWMSAutoReplenishmentIndexRoute
  '/WMS/ksef/': typeof LayoutWMSKsefIndexRoute
  '/WMS/production-orders/': typeof LayoutWMSProductionOrdersIndexRoute
  '/WMS/technologies/': typeof LayoutWMSTechnologiesIndexRoute
  '/WMS/auto-replenishment/requests/$requestId': typeof LayoutWMSAutoReplenishmentRequestsRequestIdRoute
  '/WMS/documents/doc-ki/$docKi': typeof LayoutWMSDocumentsDocKiDocKiRoute
  '/WMS/documents/doc-mmp/$docMmp': typeof LayoutWMSDocumentsDocMmpDocMmpRoute
  '/WMS/documents/doc-mmr/$docMmr': typeof LayoutWMSDocumentsDocMmrDocMmrRoute
  '/WMS/documents/doc-mmw/$docMmw': typeof LayoutWMSDocumentsDocMmwDocMmwRoute
  '/WMS/documents/doc-mmw/new': typeof LayoutWMSDocumentsDocMmwNewRoute
  '/WMS/documents/doc-pw/$docPw': typeof LayoutWMSDocumentsDocPwDocPwRoute
  '/WMS/documents/doc-pw/new': typeof LayoutWMSDocumentsDocPwNewRoute
  '/WMS/documents/doc-rw/$docRw': typeof LayoutWMSDocumentsDocRwDocRwRoute
  '/WMS/documents/doc-rw/new': typeof LayoutWMSDocumentsDocRwNewRoute
  '/WMS/documents/ex-receptions/$exReception': typeof LayoutWMSDocumentsExReceptionsExReceptionRoute
  '/WMS/documents/ex-receptions/new': typeof LayoutWMSDocumentsExReceptionsNewRoute
  '/WMS/documents/ex-releases/$exRelease': typeof LayoutWMSDocumentsExReleasesExReleaseRoute
  '/WMS/documents/ex-releases/new': typeof LayoutWMSDocumentsExReleasesNewRoute
  '/WMS/documents/purchase-orders/$purchaseOrder': typeof LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRoute
  '/WMS/documents/purchase-orders/new': typeof LayoutWMSDocumentsPurchaseOrdersNewRoute
  '/WMS/documents/sales-offers/$salesOffer': typeof LayoutWMSDocumentsSalesOffersSalesOfferRoute
  '/WMS/documents/sales-offers/new': typeof LayoutWMSDocumentsSalesOffersNewRoute
  '/WMS/documents/sales-orders/$salesOrder': typeof LayoutWMSDocumentsSalesOrdersSalesOrderRoute
  '/WMS/documents/sales-orders/new': typeof LayoutWMSDocumentsSalesOrdersNewRoute
  '/WMS/documents/warehouse-orders/$warehouseOrder': typeof LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRoute
  '/WMS/documents/zap/$zap': typeof LayoutWMSDocumentsZapZapRoute
  '/WMS/documents/zap/new': typeof LayoutWMSDocumentsZapNewRoute
  '/WMS/inventory-count/tasks/$taskId': typeof LayoutWMSInventoryCountTasksTaskIdRoute
  '/WMS/technologies/flows/$flowId': typeof LayoutWMSTechnologiesFlowsFlowIdRoute
  '/WMS/warehouses/critical-stock-report/$id': typeof LayoutWMSWarehousesCriticalStockReportIdRoute
  '/WMS/warehouses/expiration-date-report/$id': typeof LayoutWMSWarehousesExpirationDateReportIdRoute
  '/WMS/auto-replenishment/requests/': typeof LayoutWMSAutoReplenishmentRequestsIndexRoute
  '/WMS/technologies/flows/': typeof LayoutWMSTechnologiesFlowsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/developer-profile': typeof LayoutDeveloperProfileRoute
  '/settings': typeof LayoutSettingsRoute
  '/user-settings': typeof LayoutUserSettingsRoute
  '/': typeof LayoutIndexRoute
  '/WMS/dashboard': typeof LayoutWMSDashboardRoute
  '/admin/license-status': typeof LayoutAdminLicenseStatusRoute
  '/admin/roles': typeof LayoutAdminRolesRoute
  '/admin': typeof LayoutAdminIndexRoute
  '/company-settings': typeof LayoutCompanySettingsIndexRoute
  '/WMS/auto-replenishment/overview': typeof LayoutWMSAutoReplenishmentOverviewRoute
  '/WMS/auto-replenishment/policies': typeof LayoutWMSAutoReplenishmentPoliciesRoute
  '/WMS/contragents/$contragentId': typeof LayoutWMSContragentsContragentIdRoute
  '/WMS/contragents/contragents-list': typeof LayoutWMSContragentsContragentsListRoute
  '/WMS/contragents/create': typeof LayoutWMSContragentsCreateRoute
  '/WMS/documents/document-list': typeof LayoutWMSDocumentsDocumentListRoute
  '/WMS/inventory-count/dashboard': typeof LayoutWMSInventoryCountDashboardRoute
  '/WMS/inventory-count/instructions-operator': typeof LayoutWMSInventoryCountInstructionsOperatorRoute
  '/WMS/inventory-count/instructions-worker': typeof LayoutWMSInventoryCountInstructionsWorkerRoute
  '/WMS/inventory-count/plans': typeof LayoutWMSInventoryCountPlansRoute
  '/WMS/inventory-count/review': typeof LayoutWMSInventoryCountReviewRoute
  '/WMS/inventory-count/tasks': typeof LayoutWMSInventoryCountTasksRouteWithChildren
  '/WMS/ksef/$invoiceId': typeof LayoutWMSKsefInvoiceIdRoute
  '/WMS/ksef/fz': typeof LayoutWMSKsefFzRoute
  '/WMS/ksef/settings': typeof LayoutWMSKsefSettingsRoute
  '/WMS/production-orders/$order': typeof LayoutWMSProductionOrdersOrderRoute
  '/WMS/production-orders/chain': typeof LayoutWMSProductionOrdersChainRoute
  '/WMS/production-orders/create': typeof LayoutWMSProductionOrdersCreateRoute
  '/WMS/production-orders/production-orders-list': typeof LayoutWMSProductionOrdersProductionOrdersListRoute
  '/WMS/products/$product': typeof LayoutWMSProductsProductRoute
  '/WMS/products/courier-labels': typeof LayoutWMSProductsCourierLabelsRoute
  '/WMS/products/create': typeof LayoutWMSProductsCreateRoute
  '/WMS/products/label-assets': typeof LayoutWMSProductsLabelAssetsRoute
  '/WMS/products/label-templates': typeof LayoutWMSProductsLabelTemplatesRoute
  '/WMS/products/print-agent': typeof LayoutWMSProductsPrintAgentRoute
  '/WMS/products/products-list': typeof LayoutWMSProductsProductsListRoute
  '/WMS/reports/inventory-count-alerts': typeof LayoutWMSReportsInventoryCountAlertsRoute
  '/WMS/reports/mmp-discrepancies': typeof LayoutWMSReportsMmpDiscrepanciesRoute
  '/WMS/search/global-search': typeof LayoutWMSSearchGlobalSearchRoute
  '/WMS/technologies/$technology': typeof LayoutWMSTechnologiesTechnologyRoute
  '/WMS/technologies/create': typeof LayoutWMSTechnologiesCreateRoute
  '/WMS/technologies/technologies-list': typeof LayoutWMSTechnologiesTechnologiesListRoute
  '/WMS/technologies/tree': typeof LayoutWMSTechnologiesTreeRoute
  '/WMS/warehouses/$warehouse': typeof LayoutWMSWarehousesWarehouseRoute
  '/WMS/warehouses/critical-stock-reports': typeof LayoutWMSWarehousesCriticalStockReportsRoute
  '/WMS/warehouses/expiration-date-reports': typeof LayoutWMSWarehousesExpirationDateReportsRoute
  '/WMS/warehouses/location-templates': typeof LayoutWMSWarehousesLocationTemplatesRoute
  '/WMS/warehouses/warehouses-list': typeof LayoutWMSWarehousesWarehousesListRoute
  '/admin/users/$userId': typeof LayoutAdminUsersUserIdRoute
  '/company-settings/revisions/$revisionId': typeof LayoutCompanySettingsRevisionsRevisionIdRoute
  '/WMS/auto-replenishment': typeof LayoutWMSAutoReplenishmentIndexRoute
  '/WMS/ksef': typeof LayoutWMSKsefIndexRoute
  '/WMS/production-orders': typeof LayoutWMSProductionOrdersIndexRoute
  '/WMS/technologies': typeof LayoutWMSTechnologiesIndexRoute
  '/WMS/auto-replenishment/requests/$requestId': typeof LayoutWMSAutoReplenishmentRequestsRequestIdRoute
  '/WMS/documents/doc-ki/$docKi': typeof LayoutWMSDocumentsDocKiDocKiRoute
  '/WMS/documents/doc-mmp/$docMmp': typeof LayoutWMSDocumentsDocMmpDocMmpRoute
  '/WMS/documents/doc-mmr/$docMmr': typeof LayoutWMSDocumentsDocMmrDocMmrRoute
  '/WMS/documents/doc-mmw/$docMmw': typeof LayoutWMSDocumentsDocMmwDocMmwRoute
  '/WMS/documents/doc-mmw/new': typeof LayoutWMSDocumentsDocMmwNewRoute
  '/WMS/documents/doc-pw/$docPw': typeof LayoutWMSDocumentsDocPwDocPwRoute
  '/WMS/documents/doc-pw/new': typeof LayoutWMSDocumentsDocPwNewRoute
  '/WMS/documents/doc-rw/$docRw': typeof LayoutWMSDocumentsDocRwDocRwRoute
  '/WMS/documents/doc-rw/new': typeof LayoutWMSDocumentsDocRwNewRoute
  '/WMS/documents/ex-receptions/$exReception': typeof LayoutWMSDocumentsExReceptionsExReceptionRoute
  '/WMS/documents/ex-receptions/new': typeof LayoutWMSDocumentsExReceptionsNewRoute
  '/WMS/documents/ex-releases/$exRelease': typeof LayoutWMSDocumentsExReleasesExReleaseRoute
  '/WMS/documents/ex-releases/new': typeof LayoutWMSDocumentsExReleasesNewRoute
  '/WMS/documents/purchase-orders/$purchaseOrder': typeof LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRoute
  '/WMS/documents/purchase-orders/new': typeof LayoutWMSDocumentsPurchaseOrdersNewRoute
  '/WMS/documents/sales-offers/$salesOffer': typeof LayoutWMSDocumentsSalesOffersSalesOfferRoute
  '/WMS/documents/sales-offers/new': typeof LayoutWMSDocumentsSalesOffersNewRoute
  '/WMS/documents/sales-orders/$salesOrder': typeof LayoutWMSDocumentsSalesOrdersSalesOrderRoute
  '/WMS/documents/sales-orders/new': typeof LayoutWMSDocumentsSalesOrdersNewRoute
  '/WMS/documents/warehouse-orders/$warehouseOrder': typeof LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRoute
  '/WMS/documents/zap/$zap': typeof LayoutWMSDocumentsZapZapRoute
  '/WMS/documents/zap/new': typeof LayoutWMSDocumentsZapNewRoute
  '/WMS/inventory-count/tasks/$taskId': typeof LayoutWMSInventoryCountTasksTaskIdRoute
  '/WMS/technologies/flows/$flowId': typeof LayoutWMSTechnologiesFlowsFlowIdRoute
  '/WMS/warehouses/critical-stock-report/$id': typeof LayoutWMSWarehousesCriticalStockReportIdRoute
  '/WMS/warehouses/expiration-date-report/$id': typeof LayoutWMSWarehousesExpirationDateReportIdRoute
  '/WMS/auto-replenishment/requests': typeof LayoutWMSAutoReplenishmentRequestsIndexRoute
  '/WMS/technologies/flows': typeof LayoutWMSTechnologiesFlowsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/recover-password': typeof RecoverPasswordRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_layout/company-settings': typeof LayoutCompanySettingsRouteWithChildren
  '/_layout/developer-profile': typeof LayoutDeveloperProfileRoute
  '/_layout/settings': typeof LayoutSettingsRoute
  '/_layout/user-settings': typeof LayoutUserSettingsRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/WMS/dashboard': typeof LayoutWMSDashboardRoute
  '/_layout/admin/license-status': typeof LayoutAdminLicenseStatusRoute
  '/_layout/admin/roles': typeof LayoutAdminRolesRoute
  '/_layout/admin/': typeof LayoutAdminIndexRoute
  '/_layout/company-settings/': typeof LayoutCompanySettingsIndexRoute
  '/_layout/WMS/auto-replenishment/overview': typeof LayoutWMSAutoReplenishmentOverviewRoute
  '/_layout/WMS/auto-replenishment/policies': typeof LayoutWMSAutoReplenishmentPoliciesRoute
  '/_layout/WMS/auto-replenishment/requests': typeof LayoutWMSAutoReplenishmentRequestsRouteWithChildren
  '/_layout/WMS/contragents/$contragentId': typeof LayoutWMSContragentsContragentIdRoute
  '/_layout/WMS/contragents/contragents-list': typeof LayoutWMSContragentsContragentsListRoute
  '/_layout/WMS/contragents/create': typeof LayoutWMSContragentsCreateRoute
  '/_layout/WMS/documents/document-list': typeof LayoutWMSDocumentsDocumentListRoute
  '/_layout/WMS/inventory-count/dashboard': typeof LayoutWMSInventoryCountDashboardRoute
  '/_layout/WMS/inventory-count/instructions-operator': typeof LayoutWMSInventoryCountInstructionsOperatorRoute
  '/_layout/WMS/inventory-count/instructions-worker': typeof LayoutWMSInventoryCountInstructionsWorkerRoute
  '/_layout/WMS/inventory-count/plans': typeof LayoutWMSInventoryCountPlansRoute
  '/_layout/WMS/inventory-count/review': typeof LayoutWMSInventoryCountReviewRoute
  '/_layout/WMS/inventory-count/tasks': typeof LayoutWMSInventoryCountTasksRouteWithChildren
  '/_layout/WMS/ksef/$invoiceId': typeof LayoutWMSKsefInvoiceIdRoute
  '/_layout/WMS/ksef/fz': typeof LayoutWMSKsefFzRoute
  '/_layout/WMS/ksef/settings': typeof LayoutWMSKsefSettingsRoute
  '/_layout/WMS/production-orders/$order': typeof LayoutWMSProductionOrdersOrderRoute
  '/_layout/WMS/production-orders/chain': typeof LayoutWMSProductionOrdersChainRoute
  '/_layout/WMS/production-orders/create': typeof LayoutWMSProductionOrdersCreateRoute
  '/_layout/WMS/production-orders/production-orders-list': typeof LayoutWMSProductionOrdersProductionOrdersListRoute
  '/_layout/WMS/products/$product': typeof LayoutWMSProductsProductRoute
  '/_layout/WMS/products/courier-labels': typeof LayoutWMSProductsCourierLabelsRoute
  '/_layout/WMS/products/create': typeof LayoutWMSProductsCreateRoute
  '/_layout/WMS/products/label-assets': typeof LayoutWMSProductsLabelAssetsRoute
  '/_layout/WMS/products/label-templates': typeof LayoutWMSProductsLabelTemplatesRoute
  '/_layout/WMS/products/print-agent': typeof LayoutWMSProductsPrintAgentRoute
  '/_layout/WMS/products/products-list': typeof LayoutWMSProductsProductsListRoute
  '/_layout/WMS/reports/inventory-count-alerts': typeof LayoutWMSReportsInventoryCountAlertsRoute
  '/_layout/WMS/reports/mmp-discrepancies': typeof LayoutWMSReportsMmpDiscrepanciesRoute
  '/_layout/WMS/search/global-search': typeof LayoutWMSSearchGlobalSearchRoute
  '/_layout/WMS/technologies/$technology': typeof LayoutWMSTechnologiesTechnologyRoute
  '/_layout/WMS/technologies/create': typeof LayoutWMSTechnologiesCreateRoute
  '/_layout/WMS/technologies/technologies-list': typeof LayoutWMSTechnologiesTechnologiesListRoute
  '/_layout/WMS/technologies/tree': typeof LayoutWMSTechnologiesTreeRoute
  '/_layout/WMS/warehouses/$warehouse': typeof LayoutWMSWarehousesWarehouseRoute
  '/_layout/WMS/warehouses/critical-stock-reports': typeof LayoutWMSWarehousesCriticalStockReportsRoute
  '/_layout/WMS/warehouses/expiration-date-reports': typeof LayoutWMSWarehousesExpirationDateReportsRoute
  '/_layout/WMS/warehouses/location-templates': typeof LayoutWMSWarehousesLocationTemplatesRoute
  '/_layout/WMS/warehouses/warehouses-list': typeof LayoutWMSWarehousesWarehousesListRoute
  '/_layout/admin/users/$userId': typeof LayoutAdminUsersUserIdRoute
  '/_layout/company-settings/revisions/$revisionId': typeof LayoutCompanySettingsRevisionsRevisionIdRoute
  '/_layout/WMS/auto-replenishment/': typeof LayoutWMSAutoReplenishmentIndexRoute
  '/_layout/WMS/ksef/': typeof LayoutWMSKsefIndexRoute
  '/_layout/WMS/production-orders/': typeof LayoutWMSProductionOrdersIndexRoute
  '/_layout/WMS/technologies/': typeof LayoutWMSTechnologiesIndexRoute
  '/_layout/WMS/auto-replenishment/requests/$requestId': typeof LayoutWMSAutoReplenishmentRequestsRequestIdRoute
  '/_layout/WMS/documents/doc-ki/$docKi': typeof LayoutWMSDocumentsDocKiDocKiRoute
  '/_layout/WMS/documents/doc-mmp/$docMmp': typeof LayoutWMSDocumentsDocMmpDocMmpRoute
  '/_layout/WMS/documents/doc-mmr/$docMmr': typeof LayoutWMSDocumentsDocMmrDocMmrRoute
  '/_layout/WMS/documents/doc-mmw/$docMmw': typeof LayoutWMSDocumentsDocMmwDocMmwRoute
  '/_layout/WMS/documents/doc-mmw/new': typeof LayoutWMSDocumentsDocMmwNewRoute
  '/_layout/WMS/documents/doc-pw/$docPw': typeof LayoutWMSDocumentsDocPwDocPwRoute
  '/_layout/WMS/documents/doc-pw/new': typeof LayoutWMSDocumentsDocPwNewRoute
  '/_layout/WMS/documents/doc-rw/$docRw': typeof LayoutWMSDocumentsDocRwDocRwRoute
  '/_layout/WMS/documents/doc-rw/new': typeof LayoutWMSDocumentsDocRwNewRoute
  '/_layout/WMS/documents/ex-receptions/$exReception': typeof LayoutWMSDocumentsExReceptionsExReceptionRoute
  '/_layout/WMS/documents/ex-receptions/new': typeof LayoutWMSDocumentsExReceptionsNewRoute
  '/_layout/WMS/documents/ex-releases/$exRelease': typeof LayoutWMSDocumentsExReleasesExReleaseRoute
  '/_layout/WMS/documents/ex-releases/new': typeof LayoutWMSDocumentsExReleasesNewRoute
  '/_layout/WMS/documents/purchase-orders/$purchaseOrder': typeof LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRoute
  '/_layout/WMS/documents/purchase-orders/new': typeof LayoutWMSDocumentsPurchaseOrdersNewRoute
  '/_layout/WMS/documents/sales-offers/$salesOffer': typeof LayoutWMSDocumentsSalesOffersSalesOfferRoute
  '/_layout/WMS/documents/sales-offers/new': typeof LayoutWMSDocumentsSalesOffersNewRoute
  '/_layout/WMS/documents/sales-orders/$salesOrder': typeof LayoutWMSDocumentsSalesOrdersSalesOrderRoute
  '/_layout/WMS/documents/sales-orders/new': typeof LayoutWMSDocumentsSalesOrdersNewRoute
  '/_layout/WMS/documents/warehouse-orders/$warehouseOrder': typeof LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRoute
  '/_layout/WMS/documents/zap/$zap': typeof LayoutWMSDocumentsZapZapRoute
  '/_layout/WMS/documents/zap/new': typeof LayoutWMSDocumentsZapNewRoute
  '/_layout/WMS/inventory-count/tasks/$taskId': typeof LayoutWMSInventoryCountTasksTaskIdRoute
  '/_layout/WMS/technologies/flows/$flowId': typeof LayoutWMSTechnologiesFlowsFlowIdRoute
  '/_layout/WMS/warehouses/critical-stock-report/$id': typeof LayoutWMSWarehousesCriticalStockReportIdRoute
  '/_layout/WMS/warehouses/expiration-date-report/$id': typeof LayoutWMSWarehousesExpirationDateReportIdRoute
  '/_layout/WMS/auto-replenishment/requests/': typeof LayoutWMSAutoReplenishmentRequestsIndexRoute
  '/_layout/WMS/technologies/flows/': typeof LayoutWMSTechnologiesFlowsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/company-settings'
    | '/developer-profile'
    | '/settings'
    | '/user-settings'
    | '/WMS/dashboard'
    | '/admin/license-status'
    | '/admin/roles'
    | '/admin/'
    | '/company-settings/'
    | '/WMS/auto-replenishment/overview'
    | '/WMS/auto-replenishment/policies'
    | '/WMS/auto-replenishment/requests'
    | '/WMS/contragents/$contragentId'
    | '/WMS/contragents/contragents-list'
    | '/WMS/contragents/create'
    | '/WMS/documents/document-list'
    | '/WMS/inventory-count/dashboard'
    | '/WMS/inventory-count/instructions-operator'
    | '/WMS/inventory-count/instructions-worker'
    | '/WMS/inventory-count/plans'
    | '/WMS/inventory-count/review'
    | '/WMS/inventory-count/tasks'
    | '/WMS/ksef/$invoiceId'
    | '/WMS/ksef/fz'
    | '/WMS/ksef/settings'
    | '/WMS/production-orders/$order'
    | '/WMS/production-orders/chain'
    | '/WMS/production-orders/create'
    | '/WMS/production-orders/production-orders-list'
    | '/WMS/products/$product'
    | '/WMS/products/courier-labels'
    | '/WMS/products/create'
    | '/WMS/products/label-assets'
    | '/WMS/products/label-templates'
    | '/WMS/products/print-agent'
    | '/WMS/products/products-list'
    | '/WMS/reports/inventory-count-alerts'
    | '/WMS/reports/mmp-discrepancies'
    | '/WMS/search/global-search'
    | '/WMS/technologies/$technology'
    | '/WMS/technologies/create'
    | '/WMS/technologies/technologies-list'
    | '/WMS/technologies/tree'
    | '/WMS/warehouses/$warehouse'
    | '/WMS/warehouses/critical-stock-reports'
    | '/WMS/warehouses/expiration-date-reports'
    | '/WMS/warehouses/location-templates'
    | '/WMS/warehouses/warehouses-list'
    | '/admin/users/$userId'
    | '/company-settings/revisions/$revisionId'
    | '/WMS/auto-replenishment/'
    | '/WMS/ksef/'
    | '/WMS/production-orders/'
    | '/WMS/technologies/'
    | '/WMS/auto-replenishment/requests/$requestId'
    | '/WMS/documents/doc-ki/$docKi'
    | '/WMS/documents/doc-mmp/$docMmp'
    | '/WMS/documents/doc-mmr/$docMmr'
    | '/WMS/documents/doc-mmw/$docMmw'
    | '/WMS/documents/doc-mmw/new'
    | '/WMS/documents/doc-pw/$docPw'
    | '/WMS/documents/doc-pw/new'
    | '/WMS/documents/doc-rw/$docRw'
    | '/WMS/documents/doc-rw/new'
    | '/WMS/documents/ex-receptions/$exReception'
    | '/WMS/documents/ex-receptions/new'
    | '/WMS/documents/ex-releases/$exRelease'
    | '/WMS/documents/ex-releases/new'
    | '/WMS/documents/purchase-orders/$purchaseOrder'
    | '/WMS/documents/purchase-orders/new'
    | '/WMS/documents/sales-offers/$salesOffer'
    | '/WMS/documents/sales-offers/new'
    | '/WMS/documents/sales-orders/$salesOrder'
    | '/WMS/documents/sales-orders/new'
    | '/WMS/documents/warehouse-orders/$warehouseOrder'
    | '/WMS/documents/zap/$zap'
    | '/WMS/documents/zap/new'
    | '/WMS/inventory-count/tasks/$taskId'
    | '/WMS/technologies/flows/$flowId'
    | '/WMS/warehouses/critical-stock-report/$id'
    | '/WMS/warehouses/expiration-date-report/$id'
    | '/WMS/auto-replenishment/requests/'
    | '/WMS/technologies/flows/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/developer-profile'
    | '/settings'
    | '/user-settings'
    | '/'
    | '/WMS/dashboard'
    | '/admin/license-status'
    | '/admin/roles'
    | '/admin'
    | '/company-settings'
    | '/WMS/auto-replenishment/overview'
    | '/WMS/auto-replenishment/policies'
    | '/WMS/contragents/$contragentId'
    | '/WMS/contragents/contragents-list'
    | '/WMS/contragents/create'
    | '/WMS/documents/document-list'
    | '/WMS/inventory-count/dashboard'
    | '/WMS/inventory-count/instructions-operator'
    | '/WMS/inventory-count/instructions-worker'
    | '/WMS/inventory-count/plans'
    | '/WMS/inventory-count/review'
    | '/WMS/inventory-count/tasks'
    | '/WMS/ksef/$invoiceId'
    | '/WMS/ksef/fz'
    | '/WMS/ksef/settings'
    | '/WMS/production-orders/$order'
    | '/WMS/production-orders/chain'
    | '/WMS/production-orders/create'
    | '/WMS/production-orders/production-orders-list'
    | '/WMS/products/$product'
    | '/WMS/products/courier-labels'
    | '/WMS/products/create'
    | '/WMS/products/label-assets'
    | '/WMS/products/label-templates'
    | '/WMS/products/print-agent'
    | '/WMS/products/products-list'
    | '/WMS/reports/inventory-count-alerts'
    | '/WMS/reports/mmp-discrepancies'
    | '/WMS/search/global-search'
    | '/WMS/technologies/$technology'
    | '/WMS/technologies/create'
    | '/WMS/technologies/technologies-list'
    | '/WMS/technologies/tree'
    | '/WMS/warehouses/$warehouse'
    | '/WMS/warehouses/critical-stock-reports'
    | '/WMS/warehouses/expiration-date-reports'
    | '/WMS/warehouses/location-templates'
    | '/WMS/warehouses/warehouses-list'
    | '/admin/users/$userId'
    | '/company-settings/revisions/$revisionId'
    | '/WMS/auto-replenishment'
    | '/WMS/ksef'
    | '/WMS/production-orders'
    | '/WMS/technologies'
    | '/WMS/auto-replenishment/requests/$requestId'
    | '/WMS/documents/doc-ki/$docKi'
    | '/WMS/documents/doc-mmp/$docMmp'
    | '/WMS/documents/doc-mmr/$docMmr'
    | '/WMS/documents/doc-mmw/$docMmw'
    | '/WMS/documents/doc-mmw/new'
    | '/WMS/documents/doc-pw/$docPw'
    | '/WMS/documents/doc-pw/new'
    | '/WMS/documents/doc-rw/$docRw'
    | '/WMS/documents/doc-rw/new'
    | '/WMS/documents/ex-receptions/$exReception'
    | '/WMS/documents/ex-receptions/new'
    | '/WMS/documents/ex-releases/$exRelease'
    | '/WMS/documents/ex-releases/new'
    | '/WMS/documents/purchase-orders/$purchaseOrder'
    | '/WMS/documents/purchase-orders/new'
    | '/WMS/documents/sales-offers/$salesOffer'
    | '/WMS/documents/sales-offers/new'
    | '/WMS/documents/sales-orders/$salesOrder'
    | '/WMS/documents/sales-orders/new'
    | '/WMS/documents/warehouse-orders/$warehouseOrder'
    | '/WMS/documents/zap/$zap'
    | '/WMS/documents/zap/new'
    | '/WMS/inventory-count/tasks/$taskId'
    | '/WMS/technologies/flows/$flowId'
    | '/WMS/warehouses/critical-stock-report/$id'
    | '/WMS/warehouses/expiration-date-report/$id'
    | '/WMS/auto-replenishment/requests'
    | '/WMS/technologies/flows'
  id:
    | '__root__'
    | '/_layout'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/_layout/company-settings'
    | '/_layout/developer-profile'
    | '/_layout/settings'
    | '/_layout/user-settings'
    | '/_layout/'
    | '/_layout/WMS/dashboard'
    | '/_layout/admin/license-status'
    | '/_layout/admin/roles'
    | '/_layout/admin/'
    | '/_layout/company-settings/'
    | '/_layout/WMS/auto-replenishment/overview'
    | '/_layout/WMS/auto-replenishment/policies'
    | '/_layout/WMS/auto-replenishment/requests'
    | '/_layout/WMS/contragents/$contragentId'
    | '/_layout/WMS/contragents/contragents-list'
    | '/_layout/WMS/contragents/create'
    | '/_layout/WMS/documents/document-list'
    | '/_layout/WMS/inventory-count/dashboard'
    | '/_layout/WMS/inventory-count/instructions-operator'
    | '/_layout/WMS/inventory-count/instructions-worker'
    | '/_layout/WMS/inventory-count/plans'
    | '/_layout/WMS/inventory-count/review'
    | '/_layout/WMS/inventory-count/tasks'
    | '/_layout/WMS/ksef/$invoiceId'
    | '/_layout/WMS/ksef/fz'
    | '/_layout/WMS/ksef/settings'
    | '/_layout/WMS/production-orders/$order'
    | '/_layout/WMS/production-orders/chain'
    | '/_layout/WMS/production-orders/create'
    | '/_layout/WMS/production-orders/production-orders-list'
    | '/_layout/WMS/products/$product'
    | '/_layout/WMS/products/courier-labels'
    | '/_layout/WMS/products/create'
    | '/_layout/WMS/products/label-assets'
    | '/_layout/WMS/products/label-templates'
    | '/_layout/WMS/products/print-agent'
    | '/_layout/WMS/products/products-list'
    | '/_layout/WMS/reports/inventory-count-alerts'
    | '/_layout/WMS/reports/mmp-discrepancies'
    | '/_layout/WMS/search/global-search'
    | '/_layout/WMS/technologies/$technology'
    | '/_layout/WMS/technologies/create'
    | '/_layout/WMS/technologies/technologies-list'
    | '/_layout/WMS/technologies/tree'
    | '/_layout/WMS/warehouses/$warehouse'
    | '/_layout/WMS/warehouses/critical-stock-reports'
    | '/_layout/WMS/warehouses/expiration-date-reports'
    | '/_layout/WMS/warehouses/location-templates'
    | '/_layout/WMS/warehouses/warehouses-list'
    | '/_layout/admin/users/$userId'
    | '/_layout/company-settings/revisions/$revisionId'
    | '/_layout/WMS/auto-replenishment/'
    | '/_layout/WMS/ksef/'
    | '/_layout/WMS/production-orders/'
    | '/_layout/WMS/technologies/'
    | '/_layout/WMS/auto-replenishment/requests/$requestId'
    | '/_layout/WMS/documents/doc-ki/$docKi'
    | '/_layout/WMS/documents/doc-mmp/$docMmp'
    | '/_layout/WMS/documents/doc-mmr/$docMmr'
    | '/_layout/WMS/documents/doc-mmw/$docMmw'
    | '/_layout/WMS/documents/doc-mmw/new'
    | '/_layout/WMS/documents/doc-pw/$docPw'
    | '/_layout/WMS/documents/doc-pw/new'
    | '/_layout/WMS/documents/doc-rw/$docRw'
    | '/_layout/WMS/documents/doc-rw/new'
    | '/_layout/WMS/documents/ex-receptions/$exReception'
    | '/_layout/WMS/documents/ex-receptions/new'
    | '/_layout/WMS/documents/ex-releases/$exRelease'
    | '/_layout/WMS/documents/ex-releases/new'
    | '/_layout/WMS/documents/purchase-orders/$purchaseOrder'
    | '/_layout/WMS/documents/purchase-orders/new'
    | '/_layout/WMS/documents/sales-offers/$salesOffer'
    | '/_layout/WMS/documents/sales-offers/new'
    | '/_layout/WMS/documents/sales-orders/$salesOrder'
    | '/_layout/WMS/documents/sales-orders/new'
    | '/_layout/WMS/documents/warehouse-orders/$warehouseOrder'
    | '/_layout/WMS/documents/zap/$zap'
    | '/_layout/WMS/documents/zap/new'
    | '/_layout/WMS/inventory-count/tasks/$taskId'
    | '/_layout/WMS/technologies/flows/$flowId'
    | '/_layout/WMS/warehouses/critical-stock-report/$id'
    | '/_layout/WMS/warehouses/expiration-date-report/$id'
    | '/_layout/WMS/auto-replenishment/requests/'
    | '/_layout/WMS/technologies/flows/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
  RecoverPasswordRoute: typeof RecoverPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recover-password': {
      id: '/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof RecoverPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/user-settings': {
      id: '/_layout/user-settings'
      path: '/user-settings'
      fullPath: '/user-settings'
      preLoaderRoute: typeof LayoutUserSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/settings': {
      id: '/_layout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof LayoutSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/developer-profile': {
      id: '/_layout/developer-profile'
      path: '/developer-profile'
      fullPath: '/developer-profile'
      preLoaderRoute: typeof LayoutDeveloperProfileRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/company-settings': {
      id: '/_layout/company-settings'
      path: '/company-settings'
      fullPath: '/company-settings'
      preLoaderRoute: typeof LayoutCompanySettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/company-settings/': {
      id: '/_layout/company-settings/'
      path: '/'
      fullPath: '/company-settings/'
      preLoaderRoute: typeof LayoutCompanySettingsIndexRouteImport
      parentRoute: typeof LayoutCompanySettingsRoute
    }
    '/_layout/admin/': {
      id: '/_layout/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof LayoutAdminIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin/roles': {
      id: '/_layout/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof LayoutAdminRolesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/admin/license-status': {
      id: '/_layout/admin/license-status'
      path: '/admin/license-status'
      fullPath: '/admin/license-status'
      preLoaderRoute: typeof LayoutAdminLicenseStatusRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/dashboard': {
      id: '/_layout/WMS/dashboard'
      path: '/WMS/dashboard'
      fullPath: '/WMS/dashboard'
      preLoaderRoute: typeof LayoutWMSDashboardRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/technologies/': {
      id: '/_layout/WMS/technologies/'
      path: '/WMS/technologies'
      fullPath: '/WMS/technologies/'
      preLoaderRoute: typeof LayoutWMSTechnologiesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/production-orders/': {
      id: '/_layout/WMS/production-orders/'
      path: '/WMS/production-orders'
      fullPath: '/WMS/production-orders/'
      preLoaderRoute: typeof LayoutWMSProductionOrdersIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/ksef/': {
      id: '/_layout/WMS/ksef/'
      path: '/WMS/ksef'
      fullPath: '/WMS/ksef/'
      preLoaderRoute: typeof LayoutWMSKsefIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/auto-replenishment/': {
      id: '/_layout/WMS/auto-replenishment/'
      path: '/WMS/auto-replenishment'
      fullPath: '/WMS/auto-replenishment/'
      preLoaderRoute: typeof LayoutWMSAutoReplenishmentIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/company-settings/revisions/$revisionId': {
      id: '/_layout/company-settings/revisions/$revisionId'
      path: '/revisions/$revisionId'
      fullPath: '/company-settings/revisions/$revisionId'
      preLoaderRoute: typeof LayoutCompanySettingsRevisionsRevisionIdRouteImport
      parentRoute: typeof LayoutCompanySettingsRoute
    }
    '/_layout/admin/users/$userId': {
      id: '/_layout/admin/users/$userId'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof LayoutAdminUsersUserIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/warehouses/warehouses-list': {
      id: '/_layout/WMS/warehouses/warehouses-list'
      path: '/WMS/warehouses/warehouses-list'
      fullPath: '/WMS/warehouses/warehouses-list'
      preLoaderRoute: typeof LayoutWMSWarehousesWarehousesListRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/warehouses/location-templates': {
      id: '/_layout/WMS/warehouses/location-templates'
      path: '/WMS/warehouses/location-templates'
      fullPath: '/WMS/warehouses/location-templates'
      preLoaderRoute: typeof LayoutWMSWarehousesLocationTemplatesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/warehouses/expiration-date-reports': {
      id: '/_layout/WMS/warehouses/expiration-date-reports'
      path: '/WMS/warehouses/expiration-date-reports'
      fullPath: '/WMS/warehouses/expiration-date-reports'
      preLoaderRoute: typeof LayoutWMSWarehousesExpirationDateReportsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/warehouses/critical-stock-reports': {
      id: '/_layout/WMS/warehouses/critical-stock-reports'
      path: '/WMS/warehouses/critical-stock-reports'
      fullPath: '/WMS/warehouses/critical-stock-reports'
      preLoaderRoute: typeof LayoutWMSWarehousesCriticalStockReportsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/warehouses/$warehouse': {
      id: '/_layout/WMS/warehouses/$warehouse'
      path: '/WMS/warehouses/$warehouse'
      fullPath: '/WMS/warehouses/$warehouse'
      preLoaderRoute: typeof LayoutWMSWarehousesWarehouseRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/technologies/tree': {
      id: '/_layout/WMS/technologies/tree'
      path: '/WMS/technologies/tree'
      fullPath: '/WMS/technologies/tree'
      preLoaderRoute: typeof LayoutWMSTechnologiesTreeRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/technologies/technologies-list': {
      id: '/_layout/WMS/technologies/technologies-list'
      path: '/WMS/technologies/technologies-list'
      fullPath: '/WMS/technologies/technologies-list'
      preLoaderRoute: typeof LayoutWMSTechnologiesTechnologiesListRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/technologies/create': {
      id: '/_layout/WMS/technologies/create'
      path: '/WMS/technologies/create'
      fullPath: '/WMS/technologies/create'
      preLoaderRoute: typeof LayoutWMSTechnologiesCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/technologies/$technology': {
      id: '/_layout/WMS/technologies/$technology'
      path: '/WMS/technologies/$technology'
      fullPath: '/WMS/technologies/$technology'
      preLoaderRoute: typeof LayoutWMSTechnologiesTechnologyRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/search/global-search': {
      id: '/_layout/WMS/search/global-search'
      path: '/WMS/search/global-search'
      fullPath: '/WMS/search/global-search'
      preLoaderRoute: typeof LayoutWMSSearchGlobalSearchRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/reports/mmp-discrepancies': {
      id: '/_layout/WMS/reports/mmp-discrepancies'
      path: '/WMS/reports/mmp-discrepancies'
      fullPath: '/WMS/reports/mmp-discrepancies'
      preLoaderRoute: typeof LayoutWMSReportsMmpDiscrepanciesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/reports/inventory-count-alerts': {
      id: '/_layout/WMS/reports/inventory-count-alerts'
      path: '/WMS/reports/inventory-count-alerts'
      fullPath: '/WMS/reports/inventory-count-alerts'
      preLoaderRoute: typeof LayoutWMSReportsInventoryCountAlertsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/products/products-list': {
      id: '/_layout/WMS/products/products-list'
      path: '/WMS/products/products-list'
      fullPath: '/WMS/products/products-list'
      preLoaderRoute: typeof LayoutWMSProductsProductsListRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/products/print-agent': {
      id: '/_layout/WMS/products/print-agent'
      path: '/WMS/products/print-agent'
      fullPath: '/WMS/products/print-agent'
      preLoaderRoute: typeof LayoutWMSProductsPrintAgentRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/products/label-templates': {
      id: '/_layout/WMS/products/label-templates'
      path: '/WMS/products/label-templates'
      fullPath: '/WMS/products/label-templates'
      preLoaderRoute: typeof LayoutWMSProductsLabelTemplatesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/products/label-assets': {
      id: '/_layout/WMS/products/label-assets'
      path: '/WMS/products/label-assets'
      fullPath: '/WMS/products/label-assets'
      preLoaderRoute: typeof LayoutWMSProductsLabelAssetsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/products/create': {
      id: '/_layout/WMS/products/create'
      path: '/WMS/products/create'
      fullPath: '/WMS/products/create'
      preLoaderRoute: typeof LayoutWMSProductsCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/products/courier-labels': {
      id: '/_layout/WMS/products/courier-labels'
      path: '/WMS/products/courier-labels'
      fullPath: '/WMS/products/courier-labels'
      preLoaderRoute: typeof LayoutWMSProductsCourierLabelsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/products/$product': {
      id: '/_layout/WMS/products/$product'
      path: '/WMS/products/$product'
      fullPath: '/WMS/products/$product'
      preLoaderRoute: typeof LayoutWMSProductsProductRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/production-orders/production-orders-list': {
      id: '/_layout/WMS/production-orders/production-orders-list'
      path: '/WMS/production-orders/production-orders-list'
      fullPath: '/WMS/production-orders/production-orders-list'
      preLoaderRoute: typeof LayoutWMSProductionOrdersProductionOrdersListRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/production-orders/create': {
      id: '/_layout/WMS/production-orders/create'
      path: '/WMS/production-orders/create'
      fullPath: '/WMS/production-orders/create'
      preLoaderRoute: typeof LayoutWMSProductionOrdersCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/production-orders/chain': {
      id: '/_layout/WMS/production-orders/chain'
      path: '/WMS/production-orders/chain'
      fullPath: '/WMS/production-orders/chain'
      preLoaderRoute: typeof LayoutWMSProductionOrdersChainRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/production-orders/$order': {
      id: '/_layout/WMS/production-orders/$order'
      path: '/WMS/production-orders/$order'
      fullPath: '/WMS/production-orders/$order'
      preLoaderRoute: typeof LayoutWMSProductionOrdersOrderRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/ksef/settings': {
      id: '/_layout/WMS/ksef/settings'
      path: '/WMS/ksef/settings'
      fullPath: '/WMS/ksef/settings'
      preLoaderRoute: typeof LayoutWMSKsefSettingsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/ksef/fz': {
      id: '/_layout/WMS/ksef/fz'
      path: '/WMS/ksef/fz'
      fullPath: '/WMS/ksef/fz'
      preLoaderRoute: typeof LayoutWMSKsefFzRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/ksef/$invoiceId': {
      id: '/_layout/WMS/ksef/$invoiceId'
      path: '/WMS/ksef/$invoiceId'
      fullPath: '/WMS/ksef/$invoiceId'
      preLoaderRoute: typeof LayoutWMSKsefInvoiceIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/inventory-count/tasks': {
      id: '/_layout/WMS/inventory-count/tasks'
      path: '/WMS/inventory-count/tasks'
      fullPath: '/WMS/inventory-count/tasks'
      preLoaderRoute: typeof LayoutWMSInventoryCountTasksRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/inventory-count/review': {
      id: '/_layout/WMS/inventory-count/review'
      path: '/WMS/inventory-count/review'
      fullPath: '/WMS/inventory-count/review'
      preLoaderRoute: typeof LayoutWMSInventoryCountReviewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/inventory-count/plans': {
      id: '/_layout/WMS/inventory-count/plans'
      path: '/WMS/inventory-count/plans'
      fullPath: '/WMS/inventory-count/plans'
      preLoaderRoute: typeof LayoutWMSInventoryCountPlansRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/inventory-count/instructions-worker': {
      id: '/_layout/WMS/inventory-count/instructions-worker'
      path: '/WMS/inventory-count/instructions-worker'
      fullPath: '/WMS/inventory-count/instructions-worker'
      preLoaderRoute: typeof LayoutWMSInventoryCountInstructionsWorkerRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/inventory-count/instructions-operator': {
      id: '/_layout/WMS/inventory-count/instructions-operator'
      path: '/WMS/inventory-count/instructions-operator'
      fullPath: '/WMS/inventory-count/instructions-operator'
      preLoaderRoute: typeof LayoutWMSInventoryCountInstructionsOperatorRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/inventory-count/dashboard': {
      id: '/_layout/WMS/inventory-count/dashboard'
      path: '/WMS/inventory-count/dashboard'
      fullPath: '/WMS/inventory-count/dashboard'
      preLoaderRoute: typeof LayoutWMSInventoryCountDashboardRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/document-list': {
      id: '/_layout/WMS/documents/document-list'
      path: '/WMS/documents/document-list'
      fullPath: '/WMS/documents/document-list'
      preLoaderRoute: typeof LayoutWMSDocumentsDocumentListRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/contragents/create': {
      id: '/_layout/WMS/contragents/create'
      path: '/WMS/contragents/create'
      fullPath: '/WMS/contragents/create'
      preLoaderRoute: typeof LayoutWMSContragentsCreateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/contragents/contragents-list': {
      id: '/_layout/WMS/contragents/contragents-list'
      path: '/WMS/contragents/contragents-list'
      fullPath: '/WMS/contragents/contragents-list'
      preLoaderRoute: typeof LayoutWMSContragentsContragentsListRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/contragents/$contragentId': {
      id: '/_layout/WMS/contragents/$contragentId'
      path: '/WMS/contragents/$contragentId'
      fullPath: '/WMS/contragents/$contragentId'
      preLoaderRoute: typeof LayoutWMSContragentsContragentIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/auto-replenishment/requests': {
      id: '/_layout/WMS/auto-replenishment/requests'
      path: '/WMS/auto-replenishment/requests'
      fullPath: '/WMS/auto-replenishment/requests'
      preLoaderRoute: typeof LayoutWMSAutoReplenishmentRequestsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/auto-replenishment/policies': {
      id: '/_layout/WMS/auto-replenishment/policies'
      path: '/WMS/auto-replenishment/policies'
      fullPath: '/WMS/auto-replenishment/policies'
      preLoaderRoute: typeof LayoutWMSAutoReplenishmentPoliciesRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/auto-replenishment/overview': {
      id: '/_layout/WMS/auto-replenishment/overview'
      path: '/WMS/auto-replenishment/overview'
      fullPath: '/WMS/auto-replenishment/overview'
      preLoaderRoute: typeof LayoutWMSAutoReplenishmentOverviewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/technologies/flows/': {
      id: '/_layout/WMS/technologies/flows/'
      path: '/WMS/technologies/flows'
      fullPath: '/WMS/technologies/flows/'
      preLoaderRoute: typeof LayoutWMSTechnologiesFlowsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/auto-replenishment/requests/': {
      id: '/_layout/WMS/auto-replenishment/requests/'
      path: '/'
      fullPath: '/WMS/auto-replenishment/requests/'
      preLoaderRoute: typeof LayoutWMSAutoReplenishmentRequestsIndexRouteImport
      parentRoute: typeof LayoutWMSAutoReplenishmentRequestsRoute
    }
    '/_layout/WMS/warehouses/expiration-date-report/$id': {
      id: '/_layout/WMS/warehouses/expiration-date-report/$id'
      path: '/WMS/warehouses/expiration-date-report/$id'
      fullPath: '/WMS/warehouses/expiration-date-report/$id'
      preLoaderRoute: typeof LayoutWMSWarehousesExpirationDateReportIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/warehouses/critical-stock-report/$id': {
      id: '/_layout/WMS/warehouses/critical-stock-report/$id'
      path: '/WMS/warehouses/critical-stock-report/$id'
      fullPath: '/WMS/warehouses/critical-stock-report/$id'
      preLoaderRoute: typeof LayoutWMSWarehousesCriticalStockReportIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/technologies/flows/$flowId': {
      id: '/_layout/WMS/technologies/flows/$flowId'
      path: '/WMS/technologies/flows/$flowId'
      fullPath: '/WMS/technologies/flows/$flowId'
      preLoaderRoute: typeof LayoutWMSTechnologiesFlowsFlowIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/inventory-count/tasks/$taskId': {
      id: '/_layout/WMS/inventory-count/tasks/$taskId'
      path: '/$taskId'
      fullPath: '/WMS/inventory-count/tasks/$taskId'
      preLoaderRoute: typeof LayoutWMSInventoryCountTasksTaskIdRouteImport
      parentRoute: typeof LayoutWMSInventoryCountTasksRoute
    }
    '/_layout/WMS/documents/zap/new': {
      id: '/_layout/WMS/documents/zap/new'
      path: '/WMS/documents/zap/new'
      fullPath: '/WMS/documents/zap/new'
      preLoaderRoute: typeof LayoutWMSDocumentsZapNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/zap/$zap': {
      id: '/_layout/WMS/documents/zap/$zap'
      path: '/WMS/documents/zap/$zap'
      fullPath: '/WMS/documents/zap/$zap'
      preLoaderRoute: typeof LayoutWMSDocumentsZapZapRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/warehouse-orders/$warehouseOrder': {
      id: '/_layout/WMS/documents/warehouse-orders/$warehouseOrder'
      path: '/WMS/documents/warehouse-orders/$warehouseOrder'
      fullPath: '/WMS/documents/warehouse-orders/$warehouseOrder'
      preLoaderRoute: typeof LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/sales-orders/new': {
      id: '/_layout/WMS/documents/sales-orders/new'
      path: '/WMS/documents/sales-orders/new'
      fullPath: '/WMS/documents/sales-orders/new'
      preLoaderRoute: typeof LayoutWMSDocumentsSalesOrdersNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/sales-orders/$salesOrder': {
      id: '/_layout/WMS/documents/sales-orders/$salesOrder'
      path: '/WMS/documents/sales-orders/$salesOrder'
      fullPath: '/WMS/documents/sales-orders/$salesOrder'
      preLoaderRoute: typeof LayoutWMSDocumentsSalesOrdersSalesOrderRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/sales-offers/new': {
      id: '/_layout/WMS/documents/sales-offers/new'
      path: '/WMS/documents/sales-offers/new'
      fullPath: '/WMS/documents/sales-offers/new'
      preLoaderRoute: typeof LayoutWMSDocumentsSalesOffersNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/sales-offers/$salesOffer': {
      id: '/_layout/WMS/documents/sales-offers/$salesOffer'
      path: '/WMS/documents/sales-offers/$salesOffer'
      fullPath: '/WMS/documents/sales-offers/$salesOffer'
      preLoaderRoute: typeof LayoutWMSDocumentsSalesOffersSalesOfferRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/purchase-orders/new': {
      id: '/_layout/WMS/documents/purchase-orders/new'
      path: '/WMS/documents/purchase-orders/new'
      fullPath: '/WMS/documents/purchase-orders/new'
      preLoaderRoute: typeof LayoutWMSDocumentsPurchaseOrdersNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/purchase-orders/$purchaseOrder': {
      id: '/_layout/WMS/documents/purchase-orders/$purchaseOrder'
      path: '/WMS/documents/purchase-orders/$purchaseOrder'
      fullPath: '/WMS/documents/purchase-orders/$purchaseOrder'
      preLoaderRoute: typeof LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/ex-releases/new': {
      id: '/_layout/WMS/documents/ex-releases/new'
      path: '/WMS/documents/ex-releases/new'
      fullPath: '/WMS/documents/ex-releases/new'
      preLoaderRoute: typeof LayoutWMSDocumentsExReleasesNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/ex-releases/$exRelease': {
      id: '/_layout/WMS/documents/ex-releases/$exRelease'
      path: '/WMS/documents/ex-releases/$exRelease'
      fullPath: '/WMS/documents/ex-releases/$exRelease'
      preLoaderRoute: typeof LayoutWMSDocumentsExReleasesExReleaseRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/ex-receptions/new': {
      id: '/_layout/WMS/documents/ex-receptions/new'
      path: '/WMS/documents/ex-receptions/new'
      fullPath: '/WMS/documents/ex-receptions/new'
      preLoaderRoute: typeof LayoutWMSDocumentsExReceptionsNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/ex-receptions/$exReception': {
      id: '/_layout/WMS/documents/ex-receptions/$exReception'
      path: '/WMS/documents/ex-receptions/$exReception'
      fullPath: '/WMS/documents/ex-receptions/$exReception'
      preLoaderRoute: typeof LayoutWMSDocumentsExReceptionsExReceptionRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/doc-rw/new': {
      id: '/_layout/WMS/documents/doc-rw/new'
      path: '/WMS/documents/doc-rw/new'
      fullPath: '/WMS/documents/doc-rw/new'
      preLoaderRoute: typeof LayoutWMSDocumentsDocRwNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/doc-rw/$docRw': {
      id: '/_layout/WMS/documents/doc-rw/$docRw'
      path: '/WMS/documents/doc-rw/$docRw'
      fullPath: '/WMS/documents/doc-rw/$docRw'
      preLoaderRoute: typeof LayoutWMSDocumentsDocRwDocRwRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/doc-pw/new': {
      id: '/_layout/WMS/documents/doc-pw/new'
      path: '/WMS/documents/doc-pw/new'
      fullPath: '/WMS/documents/doc-pw/new'
      preLoaderRoute: typeof LayoutWMSDocumentsDocPwNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/doc-pw/$docPw': {
      id: '/_layout/WMS/documents/doc-pw/$docPw'
      path: '/WMS/documents/doc-pw/$docPw'
      fullPath: '/WMS/documents/doc-pw/$docPw'
      preLoaderRoute: typeof LayoutWMSDocumentsDocPwDocPwRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/doc-mmw/new': {
      id: '/_layout/WMS/documents/doc-mmw/new'
      path: '/WMS/documents/doc-mmw/new'
      fullPath: '/WMS/documents/doc-mmw/new'
      preLoaderRoute: typeof LayoutWMSDocumentsDocMmwNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/doc-mmw/$docMmw': {
      id: '/_layout/WMS/documents/doc-mmw/$docMmw'
      path: '/WMS/documents/doc-mmw/$docMmw'
      fullPath: '/WMS/documents/doc-mmw/$docMmw'
      preLoaderRoute: typeof LayoutWMSDocumentsDocMmwDocMmwRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/doc-mmr/$docMmr': {
      id: '/_layout/WMS/documents/doc-mmr/$docMmr'
      path: '/WMS/documents/doc-mmr/$docMmr'
      fullPath: '/WMS/documents/doc-mmr/$docMmr'
      preLoaderRoute: typeof LayoutWMSDocumentsDocMmrDocMmrRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/doc-mmp/$docMmp': {
      id: '/_layout/WMS/documents/doc-mmp/$docMmp'
      path: '/WMS/documents/doc-mmp/$docMmp'
      fullPath: '/WMS/documents/doc-mmp/$docMmp'
      preLoaderRoute: typeof LayoutWMSDocumentsDocMmpDocMmpRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/documents/doc-ki/$docKi': {
      id: '/_layout/WMS/documents/doc-ki/$docKi'
      path: '/WMS/documents/doc-ki/$docKi'
      fullPath: '/WMS/documents/doc-ki/$docKi'
      preLoaderRoute: typeof LayoutWMSDocumentsDocKiDocKiRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/WMS/auto-replenishment/requests/$requestId': {
      id: '/_layout/WMS/auto-replenishment/requests/$requestId'
      path: '/$requestId'
      fullPath: '/WMS/auto-replenishment/requests/$requestId'
      preLoaderRoute: typeof LayoutWMSAutoReplenishmentRequestsRequestIdRouteImport
      parentRoute: typeof LayoutWMSAutoReplenishmentRequestsRoute
    }
  }
}

interface LayoutCompanySettingsRouteChildren {
  LayoutCompanySettingsIndexRoute: typeof LayoutCompanySettingsIndexRoute
  LayoutCompanySettingsRevisionsRevisionIdRoute: typeof LayoutCompanySettingsRevisionsRevisionIdRoute
}

const LayoutCompanySettingsRouteChildren: LayoutCompanySettingsRouteChildren = {
  LayoutCompanySettingsIndexRoute: LayoutCompanySettingsIndexRoute,
  LayoutCompanySettingsRevisionsRevisionIdRoute:
    LayoutCompanySettingsRevisionsRevisionIdRoute,
}

const LayoutCompanySettingsRouteWithChildren =
  LayoutCompanySettingsRoute._addFileChildren(
    LayoutCompanySettingsRouteChildren,
  )

interface LayoutWMSAutoReplenishmentRequestsRouteChildren {
  LayoutWMSAutoReplenishmentRequestsRequestIdRoute: typeof LayoutWMSAutoReplenishmentRequestsRequestIdRoute
  LayoutWMSAutoReplenishmentRequestsIndexRoute: typeof LayoutWMSAutoReplenishmentRequestsIndexRoute
}

const LayoutWMSAutoReplenishmentRequestsRouteChildren: LayoutWMSAutoReplenishmentRequestsRouteChildren =
  {
    LayoutWMSAutoReplenishmentRequestsRequestIdRoute:
      LayoutWMSAutoReplenishmentRequestsRequestIdRoute,
    LayoutWMSAutoReplenishmentRequestsIndexRoute:
      LayoutWMSAutoReplenishmentRequestsIndexRoute,
  }

const LayoutWMSAutoReplenishmentRequestsRouteWithChildren =
  LayoutWMSAutoReplenishmentRequestsRoute._addFileChildren(
    LayoutWMSAutoReplenishmentRequestsRouteChildren,
  )

interface LayoutWMSInventoryCountTasksRouteChildren {
  LayoutWMSInventoryCountTasksTaskIdRoute: typeof LayoutWMSInventoryCountTasksTaskIdRoute
}

const LayoutWMSInventoryCountTasksRouteChildren: LayoutWMSInventoryCountTasksRouteChildren =
  {
    LayoutWMSInventoryCountTasksTaskIdRoute:
      LayoutWMSInventoryCountTasksTaskIdRoute,
  }

const LayoutWMSInventoryCountTasksRouteWithChildren =
  LayoutWMSInventoryCountTasksRoute._addFileChildren(
    LayoutWMSInventoryCountTasksRouteChildren,
  )

interface LayoutRouteChildren {
  LayoutCompanySettingsRoute: typeof LayoutCompanySettingsRouteWithChildren
  LayoutDeveloperProfileRoute: typeof LayoutDeveloperProfileRoute
  LayoutSettingsRoute: typeof LayoutSettingsRoute
  LayoutUserSettingsRoute: typeof LayoutUserSettingsRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutWMSDashboardRoute: typeof LayoutWMSDashboardRoute
  LayoutAdminLicenseStatusRoute: typeof LayoutAdminLicenseStatusRoute
  LayoutAdminRolesRoute: typeof LayoutAdminRolesRoute
  LayoutAdminIndexRoute: typeof LayoutAdminIndexRoute
  LayoutWMSAutoReplenishmentOverviewRoute: typeof LayoutWMSAutoReplenishmentOverviewRoute
  LayoutWMSAutoReplenishmentPoliciesRoute: typeof LayoutWMSAutoReplenishmentPoliciesRoute
  LayoutWMSAutoReplenishmentRequestsRoute: typeof LayoutWMSAutoReplenishmentRequestsRouteWithChildren
  LayoutWMSContragentsContragentIdRoute: typeof LayoutWMSContragentsContragentIdRoute
  LayoutWMSContragentsContragentsListRoute: typeof LayoutWMSContragentsContragentsListRoute
  LayoutWMSContragentsCreateRoute: typeof LayoutWMSContragentsCreateRoute
  LayoutWMSDocumentsDocumentListRoute: typeof LayoutWMSDocumentsDocumentListRoute
  LayoutWMSInventoryCountDashboardRoute: typeof LayoutWMSInventoryCountDashboardRoute
  LayoutWMSInventoryCountInstructionsOperatorRoute: typeof LayoutWMSInventoryCountInstructionsOperatorRoute
  LayoutWMSInventoryCountInstructionsWorkerRoute: typeof LayoutWMSInventoryCountInstructionsWorkerRoute
  LayoutWMSInventoryCountPlansRoute: typeof LayoutWMSInventoryCountPlansRoute
  LayoutWMSInventoryCountReviewRoute: typeof LayoutWMSInventoryCountReviewRoute
  LayoutWMSInventoryCountTasksRoute: typeof LayoutWMSInventoryCountTasksRouteWithChildren
  LayoutWMSKsefInvoiceIdRoute: typeof LayoutWMSKsefInvoiceIdRoute
  LayoutWMSKsefFzRoute: typeof LayoutWMSKsefFzRoute
  LayoutWMSKsefSettingsRoute: typeof LayoutWMSKsefSettingsRoute
  LayoutWMSProductionOrdersOrderRoute: typeof LayoutWMSProductionOrdersOrderRoute
  LayoutWMSProductionOrdersChainRoute: typeof LayoutWMSProductionOrdersChainRoute
  LayoutWMSProductionOrdersCreateRoute: typeof LayoutWMSProductionOrdersCreateRoute
  LayoutWMSProductionOrdersProductionOrdersListRoute: typeof LayoutWMSProductionOrdersProductionOrdersListRoute
  LayoutWMSProductsProductRoute: typeof LayoutWMSProductsProductRoute
  LayoutWMSProductsCourierLabelsRoute: typeof LayoutWMSProductsCourierLabelsRoute
  LayoutWMSProductsCreateRoute: typeof LayoutWMSProductsCreateRoute
  LayoutWMSProductsLabelAssetsRoute: typeof LayoutWMSProductsLabelAssetsRoute
  LayoutWMSProductsLabelTemplatesRoute: typeof LayoutWMSProductsLabelTemplatesRoute
  LayoutWMSProductsPrintAgentRoute: typeof LayoutWMSProductsPrintAgentRoute
  LayoutWMSProductsProductsListRoute: typeof LayoutWMSProductsProductsListRoute
  LayoutWMSReportsInventoryCountAlertsRoute: typeof LayoutWMSReportsInventoryCountAlertsRoute
  LayoutWMSReportsMmpDiscrepanciesRoute: typeof LayoutWMSReportsMmpDiscrepanciesRoute
  LayoutWMSSearchGlobalSearchRoute: typeof LayoutWMSSearchGlobalSearchRoute
  LayoutWMSTechnologiesTechnologyRoute: typeof LayoutWMSTechnologiesTechnologyRoute
  LayoutWMSTechnologiesCreateRoute: typeof LayoutWMSTechnologiesCreateRoute
  LayoutWMSTechnologiesTechnologiesListRoute: typeof LayoutWMSTechnologiesTechnologiesListRoute
  LayoutWMSTechnologiesTreeRoute: typeof LayoutWMSTechnologiesTreeRoute
  LayoutWMSWarehousesWarehouseRoute: typeof LayoutWMSWarehousesWarehouseRoute
  LayoutWMSWarehousesCriticalStockReportsRoute: typeof LayoutWMSWarehousesCriticalStockReportsRoute
  LayoutWMSWarehousesExpirationDateReportsRoute: typeof LayoutWMSWarehousesExpirationDateReportsRoute
  LayoutWMSWarehousesLocationTemplatesRoute: typeof LayoutWMSWarehousesLocationTemplatesRoute
  LayoutWMSWarehousesWarehousesListRoute: typeof LayoutWMSWarehousesWarehousesListRoute
  LayoutAdminUsersUserIdRoute: typeof LayoutAdminUsersUserIdRoute
  LayoutWMSAutoReplenishmentIndexRoute: typeof LayoutWMSAutoReplenishmentIndexRoute
  LayoutWMSKsefIndexRoute: typeof LayoutWMSKsefIndexRoute
  LayoutWMSProductionOrdersIndexRoute: typeof LayoutWMSProductionOrdersIndexRoute
  LayoutWMSTechnologiesIndexRoute: typeof LayoutWMSTechnologiesIndexRoute
  LayoutWMSDocumentsDocKiDocKiRoute: typeof LayoutWMSDocumentsDocKiDocKiRoute
  LayoutWMSDocumentsDocMmpDocMmpRoute: typeof LayoutWMSDocumentsDocMmpDocMmpRoute
  LayoutWMSDocumentsDocMmrDocMmrRoute: typeof LayoutWMSDocumentsDocMmrDocMmrRoute
  LayoutWMSDocumentsDocMmwDocMmwRoute: typeof LayoutWMSDocumentsDocMmwDocMmwRoute
  LayoutWMSDocumentsDocMmwNewRoute: typeof LayoutWMSDocumentsDocMmwNewRoute
  LayoutWMSDocumentsDocPwDocPwRoute: typeof LayoutWMSDocumentsDocPwDocPwRoute
  LayoutWMSDocumentsDocPwNewRoute: typeof LayoutWMSDocumentsDocPwNewRoute
  LayoutWMSDocumentsDocRwDocRwRoute: typeof LayoutWMSDocumentsDocRwDocRwRoute
  LayoutWMSDocumentsDocRwNewRoute: typeof LayoutWMSDocumentsDocRwNewRoute
  LayoutWMSDocumentsExReceptionsExReceptionRoute: typeof LayoutWMSDocumentsExReceptionsExReceptionRoute
  LayoutWMSDocumentsExReceptionsNewRoute: typeof LayoutWMSDocumentsExReceptionsNewRoute
  LayoutWMSDocumentsExReleasesExReleaseRoute: typeof LayoutWMSDocumentsExReleasesExReleaseRoute
  LayoutWMSDocumentsExReleasesNewRoute: typeof LayoutWMSDocumentsExReleasesNewRoute
  LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRoute: typeof LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRoute
  LayoutWMSDocumentsPurchaseOrdersNewRoute: typeof LayoutWMSDocumentsPurchaseOrdersNewRoute
  LayoutWMSDocumentsSalesOffersSalesOfferRoute: typeof LayoutWMSDocumentsSalesOffersSalesOfferRoute
  LayoutWMSDocumentsSalesOffersNewRoute: typeof LayoutWMSDocumentsSalesOffersNewRoute
  LayoutWMSDocumentsSalesOrdersSalesOrderRoute: typeof LayoutWMSDocumentsSalesOrdersSalesOrderRoute
  LayoutWMSDocumentsSalesOrdersNewRoute: typeof LayoutWMSDocumentsSalesOrdersNewRoute
  LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRoute: typeof LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRoute
  LayoutWMSDocumentsZapZapRoute: typeof LayoutWMSDocumentsZapZapRoute
  LayoutWMSDocumentsZapNewRoute: typeof LayoutWMSDocumentsZapNewRoute
  LayoutWMSTechnologiesFlowsFlowIdRoute: typeof LayoutWMSTechnologiesFlowsFlowIdRoute
  LayoutWMSWarehousesCriticalStockReportIdRoute: typeof LayoutWMSWarehousesCriticalStockReportIdRoute
  LayoutWMSWarehousesExpirationDateReportIdRoute: typeof LayoutWMSWarehousesExpirationDateReportIdRoute
  LayoutWMSTechnologiesFlowsIndexRoute: typeof LayoutWMSTechnologiesFlowsIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutCompanySettingsRoute: LayoutCompanySettingsRouteWithChildren,
  LayoutDeveloperProfileRoute: LayoutDeveloperProfileRoute,
  LayoutSettingsRoute: LayoutSettingsRoute,
  LayoutUserSettingsRoute: LayoutUserSettingsRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutWMSDashboardRoute: LayoutWMSDashboardRoute,
  LayoutAdminLicenseStatusRoute: LayoutAdminLicenseStatusRoute,
  LayoutAdminRolesRoute: LayoutAdminRolesRoute,
  LayoutAdminIndexRoute: LayoutAdminIndexRoute,
  LayoutWMSAutoReplenishmentOverviewRoute:
    LayoutWMSAutoReplenishmentOverviewRoute,
  LayoutWMSAutoReplenishmentPoliciesRoute:
    LayoutWMSAutoReplenishmentPoliciesRoute,
  LayoutWMSAutoReplenishmentRequestsRoute:
    LayoutWMSAutoReplenishmentRequestsRouteWithChildren,
  LayoutWMSContragentsContragentIdRoute: LayoutWMSContragentsContragentIdRoute,
  LayoutWMSContragentsContragentsListRoute:
    LayoutWMSContragentsContragentsListRoute,
  LayoutWMSContragentsCreateRoute: LayoutWMSContragentsCreateRoute,
  LayoutWMSDocumentsDocumentListRoute: LayoutWMSDocumentsDocumentListRoute,
  LayoutWMSInventoryCountDashboardRoute: LayoutWMSInventoryCountDashboardRoute,
  LayoutWMSInventoryCountInstructionsOperatorRoute:
    LayoutWMSInventoryCountInstructionsOperatorRoute,
  LayoutWMSInventoryCountInstructionsWorkerRoute:
    LayoutWMSInventoryCountInstructionsWorkerRoute,
  LayoutWMSInventoryCountPlansRoute: LayoutWMSInventoryCountPlansRoute,
  LayoutWMSInventoryCountReviewRoute: LayoutWMSInventoryCountReviewRoute,
  LayoutWMSInventoryCountTasksRoute:
    LayoutWMSInventoryCountTasksRouteWithChildren,
  LayoutWMSKsefInvoiceIdRoute: LayoutWMSKsefInvoiceIdRoute,
  LayoutWMSKsefFzRoute: LayoutWMSKsefFzRoute,
  LayoutWMSKsefSettingsRoute: LayoutWMSKsefSettingsRoute,
  LayoutWMSProductionOrdersOrderRoute: LayoutWMSProductionOrdersOrderRoute,
  LayoutWMSProductionOrdersChainRoute: LayoutWMSProductionOrdersChainRoute,
  LayoutWMSProductionOrdersCreateRoute: LayoutWMSProductionOrdersCreateRoute,
  LayoutWMSProductionOrdersProductionOrdersListRoute:
    LayoutWMSProductionOrdersProductionOrdersListRoute,
  LayoutWMSProductsProductRoute: LayoutWMSProductsProductRoute,
  LayoutWMSProductsCourierLabelsRoute: LayoutWMSProductsCourierLabelsRoute,
  LayoutWMSProductsCreateRoute: LayoutWMSProductsCreateRoute,
  LayoutWMSProductsLabelAssetsRoute: LayoutWMSProductsLabelAssetsRoute,
  LayoutWMSProductsLabelTemplatesRoute: LayoutWMSProductsLabelTemplatesRoute,
  LayoutWMSProductsPrintAgentRoute: LayoutWMSProductsPrintAgentRoute,
  LayoutWMSProductsProductsListRoute: LayoutWMSProductsProductsListRoute,
  LayoutWMSReportsInventoryCountAlertsRoute:
    LayoutWMSReportsInventoryCountAlertsRoute,
  LayoutWMSReportsMmpDiscrepanciesRoute: LayoutWMSReportsMmpDiscrepanciesRoute,
  LayoutWMSSearchGlobalSearchRoute: LayoutWMSSearchGlobalSearchRoute,
  LayoutWMSTechnologiesTechnologyRoute: LayoutWMSTechnologiesTechnologyRoute,
  LayoutWMSTechnologiesCreateRoute: LayoutWMSTechnologiesCreateRoute,
  LayoutWMSTechnologiesTechnologiesListRoute:
    LayoutWMSTechnologiesTechnologiesListRoute,
  LayoutWMSTechnologiesTreeRoute: LayoutWMSTechnologiesTreeRoute,
  LayoutWMSWarehousesWarehouseRoute: LayoutWMSWarehousesWarehouseRoute,
  LayoutWMSWarehousesCriticalStockReportsRoute:
    LayoutWMSWarehousesCriticalStockReportsRoute,
  LayoutWMSWarehousesExpirationDateReportsRoute:
    LayoutWMSWarehousesExpirationDateReportsRoute,
  LayoutWMSWarehousesLocationTemplatesRoute:
    LayoutWMSWarehousesLocationTemplatesRoute,
  LayoutWMSWarehousesWarehousesListRoute:
    LayoutWMSWarehousesWarehousesListRoute,
  LayoutAdminUsersUserIdRoute: LayoutAdminUsersUserIdRoute,
  LayoutWMSAutoReplenishmentIndexRoute: LayoutWMSAutoReplenishmentIndexRoute,
  LayoutWMSKsefIndexRoute: LayoutWMSKsefIndexRoute,
  LayoutWMSProductionOrdersIndexRoute: LayoutWMSProductionOrdersIndexRoute,
  LayoutWMSTechnologiesIndexRoute: LayoutWMSTechnologiesIndexRoute,
  LayoutWMSDocumentsDocKiDocKiRoute: LayoutWMSDocumentsDocKiDocKiRoute,
  LayoutWMSDocumentsDocMmpDocMmpRoute: LayoutWMSDocumentsDocMmpDocMmpRoute,
  LayoutWMSDocumentsDocMmrDocMmrRoute: LayoutWMSDocumentsDocMmrDocMmrRoute,
  LayoutWMSDocumentsDocMmwDocMmwRoute: LayoutWMSDocumentsDocMmwDocMmwRoute,
  LayoutWMSDocumentsDocMmwNewRoute: LayoutWMSDocumentsDocMmwNewRoute,
  LayoutWMSDocumentsDocPwDocPwRoute: LayoutWMSDocumentsDocPwDocPwRoute,
  LayoutWMSDocumentsDocPwNewRoute: LayoutWMSDocumentsDocPwNewRoute,
  LayoutWMSDocumentsDocRwDocRwRoute: LayoutWMSDocumentsDocRwDocRwRoute,
  LayoutWMSDocumentsDocRwNewRoute: LayoutWMSDocumentsDocRwNewRoute,
  LayoutWMSDocumentsExReceptionsExReceptionRoute:
    LayoutWMSDocumentsExReceptionsExReceptionRoute,
  LayoutWMSDocumentsExReceptionsNewRoute:
    LayoutWMSDocumentsExReceptionsNewRoute,
  LayoutWMSDocumentsExReleasesExReleaseRoute:
    LayoutWMSDocumentsExReleasesExReleaseRoute,
  LayoutWMSDocumentsExReleasesNewRoute: LayoutWMSDocumentsExReleasesNewRoute,
  LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRoute:
    LayoutWMSDocumentsPurchaseOrdersPurchaseOrderRoute,
  LayoutWMSDocumentsPurchaseOrdersNewRoute:
    LayoutWMSDocumentsPurchaseOrdersNewRoute,
  LayoutWMSDocumentsSalesOffersSalesOfferRoute:
    LayoutWMSDocumentsSalesOffersSalesOfferRoute,
  LayoutWMSDocumentsSalesOffersNewRoute: LayoutWMSDocumentsSalesOffersNewRoute,
  LayoutWMSDocumentsSalesOrdersSalesOrderRoute:
    LayoutWMSDocumentsSalesOrdersSalesOrderRoute,
  LayoutWMSDocumentsSalesOrdersNewRoute: LayoutWMSDocumentsSalesOrdersNewRoute,
  LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRoute:
    LayoutWMSDocumentsWarehouseOrdersWarehouseOrderRoute,
  LayoutWMSDocumentsZapZapRoute: LayoutWMSDocumentsZapZapRoute,
  LayoutWMSDocumentsZapNewRoute: LayoutWMSDocumentsZapNewRoute,
  LayoutWMSTechnologiesFlowsFlowIdRoute: LayoutWMSTechnologiesFlowsFlowIdRoute,
  LayoutWMSWarehousesCriticalStockReportIdRoute:
    LayoutWMSWarehousesCriticalStockReportIdRoute,
  LayoutWMSWarehousesExpirationDateReportIdRoute:
    LayoutWMSWarehousesExpirationDateReportIdRoute,
  LayoutWMSTechnologiesFlowsIndexRoute: LayoutWMSTechnologiesFlowsIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  LoginRoute: LoginRoute,
  RecoverPasswordRoute: RecoverPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
